<template>
  <TrfModal
    :titulo="!isTarefaAvulsa ? tituloModal : 'Cadastro de tarefa avulsa'"
    :isBtnLoading="isBtnLoading"
    :btnSaveName="(modalPermissaoAtivo || modalGruposTarefaVinculados) ? 'Sim' : edicao ? 'Salvar' : 'Cadastrar'"
    :btnCloseName="(modalPermissaoAtivo || modalGruposTarefaVinculados) ? 'Não' : 'Cancelar'"
    :changeWidthModal="true"
    :class="{ 'modal-cadastro-tarefas': true }"
    @save="executarSaveModal"
    @close="fecharModal"
    :useDispatch="true"
    @isModeloNovoSelected="handleModeloNovoSelect"
    idModal="titulo-cadastro-tarefas"
    :isAvulsa="this.isTarefaAvulsa"
    :usuarioTemPermissaoDeCriacaoDeModelo="usuarioTemPermissaoDeCriacaoDeModelo"
    :modalPermissaoAtivo="this.modalPermissaoAtivo"
    :tituloTipModelo="'Selecione esta opção se deseja criar um modelo utilizando os dados dessa tarefa'"
  >
    <div v-show="modalPermissaoAtivo">
      <div class="content" v-if="!isTarefaCliente">
        <p>
          Identificamos que o(s) usuário(s) vinculado(s) na(s) fase(s)
          listada(s) abaixo, não possui as permissões necessárias para acessar
          a(s) empresa(s) e/ou departamento vinculados a tarefa. Com isso, as
          fases relacionadas a essa(s) empresa(s) e/ou departamento não estarão
          visíveis na área de dashboard do usuário.
        </p>
        <p>
          Para resolver esta situação será preciso ajustar o cadastro do(s)
          usuário(s) responsável(eis) concedendo a permissão a esta(s)
          empresa(s) e/ou departamento.
        </p>
        <p>
          <strong
            >Gostaria de conceder esta permissão a este(s) usuário(s)?</strong
          ><br />
          OBS.: Caso não deseje conceder a permissão, será necessário atribuir
          um novo responsável para a fase que possua permissão para todas as
          empresas e/ou o departamento vinculado à tarefa.
        </p>
      </div>

      <div class="content" v-if="isTarefaCliente">
        <p>
          O(s) usuário(s) abaixo não possue(m) permissão para receber notificações de 'Avisos e lembretes'. 
          A solicitação de envio de documento para a baixa dessa tarefa só será enviada com esta permissão marcada.
        </p>
        <p>
          <strong>Gostaria de marcar a permissão de notificação de 'Avisos e lembretes' do(s) usuário(s) abaixo?</strong><br />
          OBS.: Caso não deseje conceder a permissão, será necessário alterar ou manter o responsável em branco para a empresa.
        </p>
      </div>

      <TrfTable
        v-if="errosDePermissao.length > 0"
        :dataConfig="isTarefaCliente ? dataSourceErroPermissaoTarefaCliente : dataSourceErroPermissao"
        :data="errosDePermissao"
        :isButtonMoreHidden="true"
        :showDropdownOptions="false"
        :showButtonsDefault="true"
        dataStatus=""
        :isScrollAnexos="false"
        :showEdit="false"
        :showDelete="false"
        :shouldIgnorePreDelete="true"
      >
      </TrfTable>
    </div>

    <div v-show="modalGruposTarefaVinculados && modalGruposTarefaVinculadosParceladas">
      <div class="content">
        <p>
          Esta tarefa está vinculada a um (ou mais) grupo(s) de tarefas. 
          Ao editar esta tarefa para o tipo "Parcelamento", ela será removida do(s) seguinte(s) grupo(s):
        </p>
      </div>
      <div v-if="gruposTarefaVinculados?.length != 0">
            <p>
              <strong>Grupo(s):</strong><br><br>
              <ul>
                <li v-for="(item, index) in gruposTarefaVinculados" :key="index">{{ item.nome }}</li>
              </ul>
            </p>
            <br>
            <p class="tip-label-grupo">
              Obs: Após salvar a edição desta tarefa como "Parcelamento", não será possível desfazê-la.
            </p>
            <br>
            <p>
              Deseja realmente editar esta tarefa?
            </p>
      </div>
    </div>

    <div v-show="modalGruposTarefaVinculados && !modalGruposTarefaVinculadosParceladas">
      <div class="content">
        <p>
          Esta tarefa está vinculada a um (ou mais) grupo(s) de tarefas. Ao
          inativar esta tarefa, ela será removida do(s) seguinte(s) grupo(s):
        </p>
      </div>
      <div v-if="gruposTarefaVinculados?.length != 0">
            <p>
              <strong>Grupo(s):</strong><br><br>
              <ul>
                <li v-for="(item, index) in gruposTarefaVinculados" :key="index">{{ item.nome }}</li>
              </ul>
            </p>
            <br>
            <p class="tip-label-grupo">
              Obs: Após salvar a inativação, se desejar reativar e vincular esta tarefa automaticamente
              às novas empresas, será<br>necessário ativá-lá e, em seguida, incluí-lá manualmente nos grupos desejados.
            </p>
            <br>
            <p>
              Deseja realmente inativar esta tarefa?
            </p>
      </div>
    </div>

    <div v-show="showModalDefinicaoPeriodoVigencia && !modalPermissaoAtivo && !modalGruposTarefaVinculados">
      <div class="columns">
        <div class="column is-two-fifths">
          <b>
            {{ mensagemModalVigencia }}
          </b>
        </div>
        <div class="column is-one-third">
          <TrfInput
            type="date"
            placeholder="Data de Edição"
            id="data-edicao"
            v-model="dataDeVigencia"
            ref="dataDeVigencia"
          />

          <div
            class="mensagemDeErro pb-6"
            v-if="
              !this.verificarSeFaseFoiAlterada() &&
              this.isDataDeVigenciaMenorQueAPartirDaTarefa()
            "
          >
            <span class="campo-obrigatório" style="font-size: smaller">
              A data de edição não pode ser anterior à data de início de
              controle da tarefa. Por favor informe uma data válida.
            </span>
          </div>
          <div
            class="mensagemDeErro pb-6"
            v-if="
              this.verificarSeFaseFoiAlterada() &&
              this.isDataDeVigenciaMenorQueADataDeHoje()
            "
          >
            <span class="campo-obrigatório" style="font-size: smaller">
              A data de edição não pode ser anterior à data atual. Por favor
              informe uma data válida.
            </span>
          </div>
        </div>
      </div>
      <div v-if="this.verificarEmpresasRemovidas()">
        <b>Atenção:</b> Ao clicar em salvar não serão mais criadas recorrências
        dessa tarefa para as empresas removidas.
      </div>
    </div>
    <div v-show="!modalPermissaoAtivo && !showModalDefinicaoPeriodoVigencia && !modalGruposTarefaVinculados">
      <ul class="modal-tabs has-text-weight-bold">
        <li>
          <a
            id="tab-cadastro"
            :class="{
              'is-active': tabSelecionada == 'cadastro' || tabSelecionada == '',
            }"
            @click="tabSelecionada = 'cadastro'"
            ><span>Cadastro &nbsp;</span>
          </a>
        </li>
        <li>
          <a
            id="tab-vinculo-empresas"
            :class="{ 'is-active': tabSelecionada == 'vinculo-empresas' }"
            @click="tabSelecionada = 'vinculo-empresas'"
          >
            <span>&nbsp; Vínculo de empresas</span>
          </a>
        </li>
        <li v-if="baixaPersonalizada && !isTarefaCliente && !checkFase">
          <a
            id="tab-baixa-autmatica"
            :class="{ 'is-active': tabSelecionada == 'baixa-automatica' }"
            @click="tabSelecionada = 'baixa-automatica'"
          >
            <span>&nbsp; Baixa automática</span>
          </a>
        </li>
        <li v-if="isTarefaCliente">
          <a
            id="tab-informacoes-adicionais"
            :class="{ 'is-active': tabSelecionada == 'informacoes-adicionais' }"
            @click="tabSelecionada = 'informacoes-adicionais'"
          >
            <span>&nbsp; Informações adicionais</span>
          </a>
        </li>
        <li v-if="checkFase">
          <a
            id="tab-fase"
            :class="{ 'is-active': tabSelecionada == 'fase' }"
            @click="tabSelecionada = 'fase'"
          >
            <span>&nbsp; Fases</span>
          </a>
        </li>
      </ul>
      <div v-if="loading.conteudo">
        <span class="button is-large is-fullwidth is-loading"></span>
      </div>
      <form v-show="!loading.conteudo">
        <div v-show="tabSelecionada == 'cadastro' || tabSelecionada == ''">
          <div class="columns is-flex"  v-if="isTarefaAvulsa">
            <div>
                <TrfCheckbox
                v-if="isTarefaAvulsa"
                label="Importar modelo"
                id="checkbox-importacao"
                v-model="isSelectModeloOpen"
                @change="limparInputsCadastroModelo"
                class="column is-12-mobile is-align-self-center"
                :tituloTip="tituloTip"
              />
            </div>
          </div>

          <div class="columns" v-if="isTarefaAvulsa && isSelectModeloOpen">
            <div class="column is-four-fifths is-align-content-center pt-0">
              <span class="tip-label is-size-7"> <i> Apenas modelos de departamentos para os quais você tem permissão serão exibidos.</i></span>
              <TrfSelect
                v-if="isSelectModeloOpen"
                class="is-fullWidth is-align-self-center"                
                label="Selecione um modelo"
                idSelect="select-modelo-nova-tarefa"
                placeholder="Selecione"
                ref="selectModelo"
                :options="listaDeModelosExibicao"
                :noOptionsText="'Modelo(s) não encontrado(s)'"
                :required="true"
                :canClear="true"
                @valueSelect="selecionarModelo"
                @clear="limparModelo"
              >
                <template #erroMessage>
                  <span class="campo-obrigatório"><i>Selecione um modelo para importar na sua tarefa</i></span>
                </template>
              </TrfSelect>
            </div>
            <div class="column">
              <label class="is-invisible mb-3">Importar</label>
              <TrfButton
                class="is-fullWidth is-primary"
                id="btn-importar-modelo"
                :temIcon="true"
                :disabled="modeloSelecionado == null"
                classIcon="mdi-arrow-down"
                nome="Importar"
                type="button"
                @click="verificarImportacaoDeModelo"
              />
            </div>
          </div> 
          <TrfInput
            label="Nome"
            placeholder="Nome da tarefa"
            id="nome-tarefa"
            maxLength="100"
            ref="inputNome"
            v-model="tarefa.nome"
            @keyup="ajustarEspacamentoSwitcher"
          />

          <div class="switcher-container" v-if="!isTarefaAvulsa">
            <div :class="classAjustarEspacamentoSwitcher">
              <span>Tarefa ativa</span>
              <label class="switch">
                <input
                  type="checkbox"
                  id="checkbox-status-tarefa"
                  v-model="isTarefaAtiva"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <div class="container-descricao">
            <label>
              Descrição
              <span
                class="button is-loading is-white pl-2 pr-2 is-inline-block"
                style="height: 1.25em"
                v-if="isToolbarTextEditorLoading"
              ></span>
            </label>
            <TrfToolbarTextEditor
              v-if="tabSelecionada == 'cadastro'"
              @changeText="doChangeDescricao"
              @ready="textEditorAberto"
              :tipLabel="tipLabelDescricao"
              :maxlength="descricao.maxLength"
              :allowImages="true"
              ref="textEditor"
            />
          </div>

          <div v-if="isTarefaAvulsa" class="container-anexos">
            <label> Anexos </label>
            <TrfButtonUpLoadAttachment
              tipLabel="Extensões permitidas: *.bmp, *.doc, *.dot, *.jpg, *.pdf, *.png, *.xls, *.odt, *.odf, *.rtf, *.txt, *.xml, *.html, *.gif, *.zip, *.rar, *.xlsx, *.docx, *.ppt, *.pptx, *.7z, *.jpeg, *.htm, *.csv, *.qrp, *.tdm, *.ofx, *.ofc."
              @uploadFile="upLoadAnexo"
            >
            </TrfButtonUpLoadAttachment>

            <TrfTable
              v-if="this.dataSourceErro.itens.length"
              :dataConfig="this.dataSourceErro"
              :data="this.dataSourceErro.itens"
              :isButtonMoreHidden="true"
              :showDropdownOptions="false"
              :showButtonsDefault="true"
              dataStatus=""
              :isScrollAnexos="true"
              :showEdit="false"
              :shouldIgnorePreDelete="true"
            >
            </TrfTable>
          </div>

          <TrfSelect
            v-if="!isTarefaCliente"
            :options="listaResponsaveis"
            label="Responsável"
            idSelect="select-responsavel-nova-tarefa"
            @valueSelect="(value) => atribuirValorResponsavel(value)"
            placeholder="Selecione o responsável pela tarefa"
            ref="selectResponsavel"
            :canClear="true"
            :disabled="loading.campoResponsavel"
            :loadingData="loading.campoResponsavel"
          />
          <div v-if="this.isTarefaAvulsa" class="container-switch">
            <span class="vertical-align-middle">Notificar responsável</span>
            <label class="switch switch-label">
              <input
                type="checkbox"
                id="checkbox-notificar-responsavel"
                :value="true"
                v-model="deveNotificarResponsavelTarefaAvulsa"
              />
              <span class="slider round"></span>
            </label>
            <i class="fa fa-question-circle is-size-6 help-switch" title="Selecione esta opção se deseja notificar via email o responsável pela tarefa."></i>
          </div>

          <div class="columns is-mobile is-multiline">
            <div
              class="column is-6-desktop is-12-mobile"
              :class="
                !isTarefaAvulsa && !isTarefaCliente
                  ? 'is-6-desktop is-12-mobile'
                  : 'is-12'
              "
            >
              <label>Departamento</label>
              <TrfSelect
                :options="listaDepartamentos"
                idSelect="select-departamento-nova-tarefa"
                @valueSelect="(value) => atribuirValorDepartamento(value)"
                placeholder="Selecione"
                ref="selectDepartamento"
                :disabled="loading.campoDepartamento"
                :loadingData="loading.campoDepartamento"
              />
            </div>
            <div class="column is-6" v-if="!isTarefaAvulsa">
              <TrfSelect
                placeholder="Selecione"
                :options="recorrencias"
                label="Recorrência da tarefa"
                idSelect="select-recorrencia-nova-tarefa"
                :disabled="
                  loading.campoRecorrencia || desabilitarSelectRecorrencia
                "
                :loadingData="loading.campoRecorrencia"
                @valueSelect="setRecorrencia"
                ref="selectRecorrencia"
              />
            </div>
            <div class="column is-6" v-if="!isTarefaAvulsa">
              <TrfSelect
                :options="this.competencias"
                label="Competência"
                idSelect="select-competencia-nova-tarefa"
                @valueSelect="(value) => (tarefa.competenciaId = value)"
                placeholder="Selecione"
                ref="selectCompetencia"
                :disabled="desabilitarSelectCompetencias"
              />
            </div>
            <div
              class="column is-6-desktop is-12-mobile"
              v-if="
                !isTarefaAvulsa &&
                (isTrimestral ||
                  isSemestral ||
                  isDecendial)
              "
            >
              <label class="mb-0">A partir de</label>
              <div class="columns is-mobile">
                <div class="column is-7-desktop is-6-mobile">
                  <TrfSelect
                    :options="
                      listarOpcoesSelectAPatirDeAcordoComRecorrenciaSelecionada()
                    "
                    placeholder="Selecione"
                    idSelect="select-ano-a-patir-de-nova-tarefa"
                    @valueSelect="
                      (value) => valorSelecionadoSelectAPatirDe(value)
                    "
                    ref="selectAPartirDe"
                  />
                </div>
                <div class="column is-5-desktop is-6-mobile">
                  <TrfDateInput
                    v-if="isDecendial"
                    placeholder="MM/AAAA"
                    id="data-inicio"
                    maxlength="7"
                    v-model="aPartirDe"
                    :isMesEAno="false"
                    ref="inputApartirDeComSelect"
                    :disabled="desabilitarSelectCompetencias"
                  />

                  <TrfDateInput
                    v-else
                    placeholder="AAAA"
                    id="ano-inicio"
                    maxlength="4"
                    v-model="anoAPartirDe"
                    :isAno="true"
                    ref="inputApartirDeComSelect"
                    :disabled="desabilitarSelectCompetencias"
                  />
                </div>
              </div>
            </div>
            <div
              class="column is-6"
              v-if="
                !isTrimestral &&
                !isSemestral &&
                !isDecendial &&
                !isTarefaAvulsa
              "
            >
              <TrfDateInput
                v-if="isSemanal"
                label="A partir de"
                placeholder="DD/MM/AAAA"
                id="data-inicio"
                maxlength="10"
                v-model="aPartirDe"
                :isDiaMesEAno="true"
                ref="inputApartirDe"
                :disabled="desabilitarSelectCompetencias"
              />

              <TrfDateInput
                v-else
                label="A partir de"
                placeholder="MM/AAAA"
                id="data-inicio"
                maxlength="7"
                v-model="aPartirDe"
                :isMesEAno="false"
                ref="inputApartirDe"
                :disabled="desabilitarSelectCompetencias"
              />
            </div>
            <div
              class="column is-mobile is-6-desktop is-12-mobile has-checkbox-ultimo-dia"
              v-if="
                isMensal ||
                isTrimestral ||
                isSemestral ||
                isDecendial
              "
            >
              <label class="mb-0" :class="{ labelObrigatorio: labelPrazoFinal && !ultimoDiaPrazoEntregaFinal }"
                >Prazo de entrega final</label
              >
              <div class="columns is-mobile is-multiline">
                <div class="column is-4-desktop is-4-mobile">
                  <TrfNumberInput
                    @update:modelValue="
                      (value) => {
                        diaPrazoEntregaFinal = value;
                        this.validarCamposVaziosPrazoFinalMensal();
                      }
                    "
                    :disableErrorMessage="true"
                    :desabilitarDecimal="true"
                    v-model="diaPrazoEntregaFinal"
                    ref="inputDiaPrazoEntregaFinal"
                    id="select-dia-prazo-entrega-final-nova-tarefa"
                    maxLength="2"
                    min="1"
                    :max="isDecendial ? '5' : '31'"
                    :desabilitarInput="ultimoDiaPrazoEntregaFinal"
                    :required="!ultimoDiaPrazoEntregaFinal"
                  />
                </div>
                <div class="column is-7-desktop is-8-mobile">
                  <TrfSelect
                    :options="tiposDePrazosEntregas"
                    :placeholder="ultimoDiaPrazoEntregaFinal? '' : 'Selecione'"
                    idSelect="select-mes-prazo-entrega-final-nova-tarefa"
                    :disabled="ultimoDiaPrazoEntregaFinal"
                    :disableErrorMessage="true"
                    @valueSelect="
                      (value) => {
                        tarefa.tipoPrazoEntregaFinalId = value;
                        this.validarCamposVaziosPrazoFinalMensal();
                      }
                    "
                    ref="selectMesPrazoEntregaFinal"
                    :required="!ultimoDiaPrazoEntregaFinal"
                  />
                </div>
                <div class="column is-full mensagemErroPersonalizada" :class="{'is-invisible': !labelPrazoFinal || ultimoDiaPrazoEntregaFinal}">
                  <span class="labelErroPersonalizado" :class="{ labelObrigatorio: labelPrazoFinal && !ultimoDiaPrazoEntregaFinal }">Campo(s) obrigatório(s).</span>
                </div>
                <TrfCheckbox
                  v-if="(isMensal || isTrimestral || isSemestral)"
                  label="Último dia útil do mês"
                  id="checkbox-ultimo-dia-mes-prazo-entrega-final"
                  class="column mr-4"
                  style="flex-shrink: 0"
                  tituloTip="Selecione esta opção caso deseje que o prazo de entrega final da tarefa seja ajustado para o último dia útil de cada mês."
                  v-model="ultimoDiaPrazoEntregaFinal"
                  @update:modelValue="$event => (atualizarCamposDosSelectsDeDiaETipoDePrazoEntregaFinal($event))"
                />
              </div>
            </div>
            <div
              class="column is-6-desktop is-mobile is-12-mobile has-checkbox-ultimo-dia"
              v-if="
                !isTarefaCliente &&
                (isMensal ||
                  isTrimestral ||
                  isSemestral ||
                  isDecendial)
              "
            >

              <label :class="{ labelObrigatorio: labelPrazoLegal && !ultimoDiaPrazoEntregaLegal }"
                >Prazo de entrega legal</label
              >
              <div class="columns is-mobile is-multiline">
                <div class="column is-4-desktop is-4-mobile">
                  <TrfNumberInput
                    @update:modelValue="
                      (value) => {
                        diaPrazoEntregaLegal = value;
                        this.validarCamposVaziosPrazoLegalMensal();
                      }
                    "
                    v-model="diaPrazoEntregaLegal"
                    :desabilitarDecimal="true"
                    ref="inputDiaPrazoEntregaLegal"
                    id="select-dia-prazo-entrega-legal-nova-tarefa"
                    maxLength="2"
                    min="1"
                    :max="isDecendial ? '5' : '31'"
                    :desabilitarInput="ultimoDiaPrazoEntregaLegal"
                    :required="!ultimoDiaPrazoEntregaLegal"
                    :disableErrorMessage="true"
                  />
                </div>
                <div class="column is-7-desktop is-8-mobile">
                  <TrfSelect
                    :options="tiposDePrazosEntregas"
                    :placeholder="ultimoDiaPrazoEntregaLegal? '' : 'Selecione'"
                    idSelect="select-mes-prazo-entrega-legal-nova-tarefa"
                    @valueSelect="
                      (value) => {
                        tarefa.tipoPrazoEntregaLegalId = value;
                        this.validarCamposVaziosPrazoLegalMensal();
                      }
                    "
                    ref="selectMesPrazoEntregaLegal"
                    :disableErrorMessage="true"
                    :disabled="ultimoDiaPrazoEntregaLegal"
                    :required="!ultimoDiaPrazoEntregaLegal"
                  />
                </div>
                <div class="column is-full mensagemErroPersonalizada" :class="{'is-invisible': !labelPrazoLegal || ultimoDiaPrazoEntregaLegal}">
                  <span class="labelErroPersonalizado" :class="{ labelObrigatorio: labelPrazoLegal && !ultimoDiaPrazoEntregaLegal }">Campo(s) obrigatório(s).</span>
                </div>
                <TrfCheckbox
                  v-if="(isMensal || isTrimestral || isSemestral)"
                  label="Último dia útil do mês"
                  id="checkbox-ultimo-dia-mes-prazo-entrega-legal"
                  class="column mr-4"
                  style="flex-shrink: 0"
                  tituloTip="Selecione esta opção caso deseje que o prazo de entrega legal da tarefa seja ajustado para o último dia útil de cada mês."
                  v-model="ultimoDiaPrazoEntregaLegal"
                   @update:modelValue="$event => (atualizarCamposDosSelectsDeDiaETipoDePrazoEntregaLegal($event))"
                />
              </div>
            </div>
            <div
              class="column is-6"
              v-if="
                !isMensal &&
                !isTrimestral &&
                !isSemestral &&
                !isDecendial &&
                !isSemanal
              "
            >
              <TrfDateInput
                label="Prazo de entrega final"
                placeholder="DD/MM"
                id="prazo-entrega-final"
                maxlength="5"
                v-model="prazoEntrega"
                :isMesEAno="true"
                ref="inpuPrazoEntrega"
              />
            </div>
            <div
              class="column is-6"
              v-if="
                !isTarefaCliente &&
                !isMensal &&
                !isTrimestral &&
                !isSemestral &&
                !isDecendial &&
                !isSemanal
              "
            >
              <TrfDateInput
                label="Prazo de entrega legal"
                placeholder="DD/MM"
                id="prazo-entrega-legal"
                maxlength="5"
                v-model="prazoLegal"
                :isMesEAno="true"
                ref="inpuPrazoEntregaLegal"
              />
            </div>
            <div
              :class="{
                'column is-6': isTarefaCliente,
                'column is-12': !isTarefaCliente,
              }"
              v-if="isSemanal"
            >
              <TrfSelect
                label="Prazo de entrega final"
                :options="diasDaSemanaOptions"
                placeholder="Selecione"
                idSelect="select-dia-da-semana-prazo-entrega-final"
                @valueSelect="setDiaDaSemana"
                ref="selectDiaDaSemanaPrazoEntregaFinal"
              />
            </div>
          </div>

          <div class="mb-2">
            <div v-if="deveExibirAjusteVencimentoDiasNaoUteis" class="columns is-mobile">
              <TrfCheckbox
                label="Ajustar vencimento em dias não úteis"
                id="checkbox-ajustar-vencimento-dias-nao-uteis"
                v-model="ajustarVencimentoDiasNaoUteis"
                tituloTip="Ajustar vencimento para dias não úteis (domingo e feriado)"
                class="column"
                @update:modelValue="setAjustarVencimento"
              />
            </div>
            
            <div v-show="deveExibirAjusteVencimentoDiasNaoUteis && ajustarVencimentoDiasNaoUteis" class="ml-4 mb-3">
              <TrfRadioFields
                :listaDeOpcoes="opcoesAjusteVencimento"
                @update:valorSelecionado="setTipoAjusteVencimentoId"
                name="tipo-ajuste-vencimento"
                id="radio-fields-ajuste-vencimento"
                ref="radioFieldsAjusteVencimento"
              />
            </div>
          </div>
          
          <div v-if="deveExibirSabadoDiaUtil" class="container-switch">
            <span class="vertical-align-middle">Considerar o sábado como dia útil</span>
            <label class="switch switch-label">
              <input
                type="checkbox"
                data-label="switch-sabado-dia-util"
                v-model="tarefa.isSabadoDiaUtil"
                :value="false"
                :disabled="isSabadoSelecionado"
              />
              <span class="slider round" :class="{ 'cursor-not-allowed': isSabadoSelecionado }"></span>
            </label>
            <i class="fa fa-question-circle is-size-6 help-switch" title="Selecione esta opção se deseja considerar o sábado como dia útil nesta tarefa."></i>
          </div>

          <div class="is-flex">
            <TrfCheckbox
              label="Gera multa por atraso"
              id="checkbox-gera-multa"
              v-model="geraMulta"
              class="mr-4"
              style="flex-shrink: 0"
            />
            <div v-if="!isTarefaAvulsa" style="flex-shrink: 1">
              <TrfCheckbox
                v-if="!isTarefaCliente"
                label="Parcelamento"
                id="checkbox-parcelamento"
                v-model="tarefa.parcelada"
                :disabled="disableParcelasEdicao || checkFase"
                @update:modelValue="$event => ((checkFase = false), deveExibirModalTarefasParceladas($event))"
              />
              <p
                v-if="edicao && tarefa.parcelada && isEdicaoConverteParaParcela"
                class="mensagemDeErro"
                style="height: auto; margin-top: -1.25em"
              >
                <span class="campo-obrigatório">
                  Após realizar essa ação, não será possível desfazê-la. Os
                  históricos existentes serão mantidos e as futuras recorrências
                  serão geradas de forma parcelada.
                </span>
              </p>
            </div>
            <div class="ml-4">
              <TrfCheckbox
                v-if="!isTarefaCliente"
                label="Fases"
                id="checkbox-fase"
                v-model="checkFase"
                :disabled="tarefa.parcelada"
                @update:modelValue="tratarToggleFase"
              />
            </div>
          </div>

          <div
            class="notification is-info is-light px-3 py-2"
            v-if="checkFase"
          >
            A aba fases foi habilitada para que possa incluir as fases
            necessárias.
          </div>

          <TrfInput
            v-if="baixaPersonalizada && isTarefaCliente"
            label="Baixa personalizada"
            placeholder="Titulo para baixa personalizada"
            id="baixa-personalizada"
            maxLength="100"
            tipLabel="Adicionando um novo documento, o título + período serão sugeridos pelo sistema. Confirmando o título, a tarefa correspondente ao período será baixada automaticamente."
            v-model="tarefa.baixaPersonalizada"
            :required="false"
          />
        </div>

        <div v-show="tabSelecionada == 'vinculo-empresas'">
          <TrfCardInfo
            v-if="tarefa.parcelada"
            mensagem="Caso possua parcelamento ativo, informe a partir de qual parcela deseja iniciar o controle de recorrência e a quantidade total
            para cada empresa. Ex: 5 / 12 = controle a partir da 5ª parcela."
          />

          <TrfCardInfo
            v-if="isTarefaCliente"
            mensagem="Somente usuários com permissão para a empresa serão listados na seleção de responsável"
          />

          <div class="columns">
            <div class="column is-12 pb-0">
              <label :class="{ labelObrigatorio: campoVazio }"
                >Empresas
                <span
                  class="button is-loading is-white pl-2 pr-2 is-inline-block"
                  style="height: 1.25em"
                  v-if="loading.campoEmpresas"
                ></span
              ></label>
              <Multiselect
                mode="multiple"
                :options="listaEmpresas"
                v-model="empresas.selecionadas"
                class="multiselect-econtador"
                :placeholder="placeholderEmpresa"
                :closeOnSelect="false"
                :searchable="true"
                :canClear="false"
                noResultsText="Empresa(s) não encontrada(s)."
                id="select-add-empresa-nova-tarefa"
                ref="multiselect"
                :class="{
                  inValida: campoVazio,
                  'trf-is-placeholder-customizado': hasCustomEmpresaPlaceholder,
                }"
                @select="selecionarEmpresa"
                @deselect="removerEmpresa"
                :disabled="loading.campoEmpresas"
              >
                <template v-slot:multiplelabel="{}">
                  <div class="multiselect-multiple-label">
                    {{ dataSource.itens.length }} empresas selecionadas
                  </div>
                </template>
              </Multiselect>
              <div class="mensagemDeErro">
                <span v-if="campoVazio" class="campo-obrigatório"
                  >Vincule empresas em sua tarefa.</span
                >
              </div>
            </div>
          </div>
          <div class="btn-container">
            <TrfButton
              nome="Adicionar todas"
              :temIcon="true"
              classIcon="mdi-plus-thick"
              classCor="is-light"
              id="btn-add-todas-empresas"
              width="115px"
              height="22px"
              fontSize="12px"
              type="button"
              :disabled="loading.campoEmpresas"
              @click.prevent="selecionarTodasAsEmpresas"
            />

            <TrfButton
              nome="Remover todas"
              :temIcon="true"
              classIcon="mdi-minus-thick"
              classCor="is-light"
              id="btn-remover-todas-empresas"
              width="115px"
              height="22px"
              fontSize="12px"
              type="button"
              :disabled="loading.campoEmpresas"
              @click.prevent="removerTodasAsEmpresas"
            />
          </div>
          <div
            v-if="this.dataSource.itens.length"
            class="input-busca"
            style="
              width: calc(100% - 138px);
              float: right;
              margin-bottom: -48px;
              margin-right: 12px;
            "
          >
            <TrfInput
              placeholder="Pesquise pelo nome ou código da empresa"
              id="busca-empresa"
              :required="false"
              ref="inputBuscaTabela"
              v-model="buscaEmpresaTabela"
            />
          </div>
          <TrfTable
            v-if="this.dataSource.itens.length"
            :dataConfig="this.dataSource"
            :data="this.dataSource.itens"
            :isButtonMoreHidden="true"
            :showDropdownOptions="false"
            :showButtonsDefault="true"
            dataStatus=""
            :isScrollable="true"
            :showEdit="false"
            :shouldIgnorePreDelete="true"
            :isSelectable="false"
            :busca="buscaEmpresaTabela"
            idTable="empresaCadastroTable"
          >

          <template #responsavelTarefaCliente="{ item }" v-if="isTarefaCliente" >
            <TrfSelect
                :options="Array.isArray(obterOptionsSelectResponsavelEmpresas[item.id]) ? obterOptionsSelectResponsavelEmpresas[item.id] : []"
                :idSelect="`select-responsavel-cliente-${item.id}`"
                @valueSelect="(value) => (atualizarComplementoTarefaCliente(item.id, value))"
                @clear="() => (removerEmpresaDoComplementoDaTarefa(item.id))"
                :ref="`selectResponsavelTarefaCliente${item.id}`"
                placeholder="Selecione o responsável"
                :canClear="true"
                :required="false"
                v-model="opcaoResponsavelSelecionada[item.id]"
                @click="buscarResponsaveisParaEmpresaSelecionada(item.id)"
                :loadingData="loadingResponsaveisTarefaCliente[item.id]"
                :disabled="loadingResponsaveisTarefaCliente[item.id]"
                noResultsText="Usuários(s) cliente(s) não encontrado(s)."
              />
          </template>

            <template #aPartirDaParcela="{ item }">
              <div style="float: right; text-align: right">
                <TrfNumberInput
                  :id="`a-partir-da-parcela-${item.id}`"
                  :desabilitarDecimal="true"
                  style="width: 5em; margin-top: -5px; display: inline-block"
                  maxLength="3"
                  min="1"
                  :desabilitarInput="item.parcelamento.validacao.atual.disabled"
                  :required="false"
                  v-model="item.parcelamento.parcelaAtual"
                  @update:modelValue="
                    ($event) => validarLinhaParcela($event, 'atual', item)
                  "
                />
                <div
                  v-if="!getParcelamentoValidoTemplate(item, 'atual')"
                  class="mensagemDeErro"
                  style="margin-top: -1em; line-height: 1.25em"
                >
                  <span class="campo-obrigatório">
                    {{ renderErrorMessage(item, "atual") }}
                  </span>
                </div>
              </div>
            </template>
            <template #divisor="{}">
              <p style="line-height: 2.6em">/</p>
            </template>
            <template #quantidadeTotal="{ item }">
              <TrfNumberInput
                :id="`quantidade-total-parcelas-${item.id}`"
                style="width: 5em; margin-top: -5px"
                maxLength="3"
                min="1"
                :required="false"
                :desabilitarInput="item.parcelamento.validacao.final.disabled"
                v-model="item.parcelamento.parcelaFinal"
                @update:modelValue="
                  ($event) => validarLinhaParcela($event, 'final', item)
                "
              />
              <div
                v-if="!getParcelamentoValidoTemplate(item, 'atual')"
                class="mensagemDeErro"
                style="margin-top: -1em; line-height: 1.25em"
              >
                <span class="campo-obrigatório">
                  {{ renderErrorMessage(item, "final") }}
                </span>
              </div>
            </template>
          </TrfTable>
        </div>

        <div
          v-show="tabSelecionada == 'baixa-automatica'"
          v-if="!isTarefaCliente"
        >
          <div
            class="container-baixa-padrao"
            v-if="this.edicao && this.tarefaRecebida?.documentoReferencia"
          >
            <label>Baixa padrão</label>
            <p>
              Esta tarefa possui baixa automática a partir do envio de
              documentos pelos sistemas Desktop da linha Pack ou UpDocs.
              <a
                href="https://ajuda.alterdata.com.br/packupbase/tema-etarefas/etarefas-baixa-automatica-envios-que-geram-a-baixa-automatica-da-tarefa"
                target="_blank"
                >Clique para saber mais.
              </a>
            </p>
          </div>

          <div
            class="container-baixa-iss-icms"
            v-if="deveExibirAvisoGuiasIssEIcms"
          >
            <label>Atenção:</label>
            <p>
              Para que a baixa automática a partir do envio da
              {{ tipoDaGuia }} ocorra, é necessário que o endereço e o número do
              IBGE da empresa estejam configurados corretamente no cadastro.
              <a :href="infoLink" target="_blank">Clique para saber mais. </a>
            </p>
            <br />
          </div>

          <TrfAutocomplete
            label="Baixa personalizada"
            placeholder="Titulo para baixa personalizada"
            id="baixa-personalizada"
            maxLength="100"
            tipLabel="Adicionando um novo documento, o título + período serão sugeridos pelo sistema. Confirmando o título, a tarefa correspondente ao período será baixada automaticamente."
            v-model="tarefa.baixaPersonalizada"
            :required="false"
            :items="trechosBaixasPersonalizadas"
            @update:modelValue="(value) => {
                        tarefa.baixaPersonalizada = value;
                      }"
            @update:results="adquirirTrechosBaixasPersonalizadasTarefa()"
            :isLoading="loadingTrechosBaixasPersonalizadasDocumentos"
          />

          <TrfCheckbox
            label="Desativar conclusão manual da tarefa"
            id="checkbox-conclusao-manual"
            v-model="tarefa.desativarConclusaoManual"
            class="pb-3"
            tituloTip="Selecione esta opção para desativar a conclusão manual da tarefa. Nesse caso, ela só poderá ser concluída de forma automática."
            ref="checkboxConclusaoManual"
          />
        </div>

        <div
          v-show="tabSelecionada == 'informacoes-adicionais'"
          v-if="isTarefaCliente"
          class="pb-5"
        >
          <label>Categorias</label>
          <TrfSelect
            :options="listaCategorias"
            idSelect="select-categoria-nova-tarefa"
            @valueSelect="(value) => {idCategoriaDaTarefa = value}"
            placeholder="Selecione"
            ref="selectCategoria"
            :disabled="loading.campoCategoria"
            :loadingData="loading.campoCategoria"
            :required="true"
          />
          <TrfCardInfo titulo="Legenda">
            <template v-slot:card-body>
              <p class="card-info-body">
                <strong>@NomeDestinatario</strong> = Nome do usuário cliente.
              </p>
              <p class="card-info-body">
                <strong>@Periodo</strong> = Competência da tarefa.
              </p>
              <p class="card-info-body">
                <strong>@NomeDaTarefa</strong> = Nome da tarefa.
              </p>
              <p class="card-info-body">
                <strong>@NomeDaEmpresa</strong> = Nome da empresa.
              </p>
            </template>
          </TrfCardInfo>
          <div class="container-descricao">
            <TrfToolbarTextEditor
              label="Layout de notificação"
              tipLabel="Adicione o texto que será enviado para o cliente na notificação. Esta notificação será enviada no dia do prazo de entrega, periodicamente, de acordo com a recorrência da tarefa."
              @changeText="
                (value) => (this.tarefa.textoLayoutNotificacao = value)
              "
              @ready="($event) => (isToolbarTextEditorLoading = $event)"
              :isObrigatorio="true"
              ref="textEditorLayoutNotificacao"
            />
          </div>
        </div>

        <div v-show="tabSelecionada == 'fase'" v-if="checkFase" class="pb-5">
          <TrfCadastroDeFases
            ref="cadastroDeFases"
            :isEnabled="true"
            :isEdicao="edicao"
            :responsaveis="listaResponsaveis"
            :listagemRecebida="listagemFases"
            :listaDepartamentosFase="listaDepartamentosFase"
            :tiposDeBaixa="isTarefaAvulsa? ['manual', 'personalizada'] : ['manual', 'automatica', 'personalizada']"
            :utilizaAutoComplete="isTarefaAvulsa? false : true"
            :loadingCampoDepartamento="loading.campoDepartamento"
            :atributosCadastro="this.atributosCadastro"
            @update:lista-fases="($event) => listagemFases = $event"
            @error:fases-ordem-invalida="definirOrdemFaseInvalida"
            @update:posicao-switcher="($event) => ajustarEspacamentoSwitcher()"
          ></TrfCadastroDeFases>
        </div>
      </form>
    </div>
  </TrfModal>
</template>

<script>
import TrfModal from "./index.vue";
import TrfInput from "../Input";
import Multiselect from "@vueform/multiselect";
import TrfButton from "../Button";
import TrfNumberInput from "../Input/TrfNumberInput.vue";
import TrfDateInput from "../Input/TrfDateInput.vue";
import TrfSelect from "../Select";
import TrfToolbarTextEditor from ".././ToolbarTextEditor";
import Tarefa from "../../views/CadastroTarefas/model/tarefa";
import TrfTable from "../Table";
import TrfCheckbox from "../Checkbox";
import TrfCardInfo from "../CardInfo";
import TrfButtonUpLoadAttachment from "../ButtonUpload/TrfButtonUpLoadAttachment.vue";
import { service } from "../../views/CadastroTarefas/service/cadastro-tarefas-service.js";
import { usuarioService } from "../../service/usuario-service";
import { trechoBaixaPersonalizadaService } from "../../service/trecho-baixa-personalizada.js";
import { toastUtils } from "../../util/toast.utils.js";
import { utils } from "../../util/utils.js";
import { syncUtils } from "../../util/sync.utils";
import { truncateText } from "../../util/intl.js";
import { telemetriaService } from "../../service/telemetria-service";
import { tipoTarefaEnum } from "../../views/CadastroTarefas/enum/tipoTarefaEnum.js";
import { defineAsyncComponent } from "vue";
import { usuarioEmpresaService } from "../../service/usuario-empresa-service";
import ModeloDeTarefaModel from "../../views/CadastroDeModelos/model/modelo-de-tarefa.js";
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js"

import TrfAutocomplete from "../Input/TrfAutocomplete.vue";
import { recorrenciaEnum } from "../../enums/recorrenciaEnum.js";
import { tipoAjusteVencimentoEnum } from "../../enums/tipoAjusteVencimentoEnum.js";
import { tipoPrazoDeEntregaEnum } from "../../enums/tipoPrazoDeEntregaEnum.js";
import { diaDaSemanaEnum } from "../../enums/diaDaSemanaEnum.js";

export default {
  name: "TrfModalCadastroTarefas",
  components: {
    TrfModal,
    TrfInput,
    TrfNumberInput,
    TrfSelect,
    Multiselect,
    TrfButton,
    TrfDateInput,
    TrfTable,
    TrfToolbarTextEditor,
    TrfCheckbox,
    TrfRadioFields: defineAsyncComponent(() =>
      import("../RadioFields")
    ),
    TrfCardInfo,
    TrfButtonUpLoadAttachment,
    TrfCadastroDeFases: defineAsyncComponent(() =>
      import("../CadastroDeFases/index.vue")
    ),
    TrfAutocomplete
  },
  props: {
    loading: {
      type: [Object],
      required: false,
      default: () => {
        return {
          conteudo: false,
          campoEmpresas: false,
          campoResponsavel: false,
          campoDepartamento: false,
          campoRecorrencia: false,
          campoCategoria: false
        };
      },
    },
    isModalActive: Boolean,
    isTarefaAvulsa: Boolean,
    titulo: {
      type: String,
      required: false,
      default: "",
    },
    edicao: Boolean,
    listaResponsaveis: {
      type: Array,
      required: false,
    },
    listaResponsaveisClientes: {
      type: Array,
      required: false,
    },
    listaDepartamentos: {
      type: Array,
      required: false,
    },
    listaDepartamentosFase: {
      type: Array,
      required: false,
    },
    listaRecorrenciaECompetencia: {
      type: Array,
      required: false,
    },
    tiposDePrazosEntregas: {
      type: Array,
      required: false,
    },
    listaEmpresas: {
      type: Array,
      required: false,
    },
    baixaPersonalizada: {
      type: Boolean,
      default: false,
    },
    isTarefaCliente: {
      type: Boolean,
      default: false,
    },
    gruposTarefaVinculados: {
      type: Array,
      required: false,
    },
    listaCategorias: {
      type: Array,
      required: false,
    },
    listaDeModelos : {
      type: Array,
      required: false,
    },
    listaDeModelosExibicao:{
      type: Array,
      required: false,
    }
  },
  data() {
    return {
      disableParcelasEdicao: false,
      dataDeVigencia: null,
      tituloModal: this.titulo,
      recorrencia: "",
      isDefinicaoDoPeriodoDeVigenciaNecessaria: false,
      recorrencias: [],
      tarefa: new Tarefa(),
      tabSelecionada: "cadastro",
      competencias: [],
      diasPrazoEntrega: [],
      diaPrazoEntregaFinal: "1",
      diaPrazoEntregaLegal: "1",
      ultimoDiaPrazoEntregaLegal: false,
      ultimoDiaPrazoEntregaFinal: false,
      prazoLegal: "",
      prazoEntrega: "",
      aPartirDe: "",
      anoAPartirDe: "",
      statusId: 1,
      padrao: false,
      isTarefaAtiva: true,
      deveNotificarResponsavelTarefaAvulsa: true,
      geraMulta: false,
      campoVazio: false,
      labelPrazoFinal: false,
      labelPrazoLegal: false,
      isBtnLoading: false,
      idCategoriaDaTarefa: null,
      classAjustarEspacamentoSwitcher: "posicao-switcher-status-tarefa",
      empresas: {
        semAcesso: [],
        semETarefas: [],
        selecionadas: []
      },
      desabilitarSelectCompetencias: true,
      dataSource: {
        columns: [
          {
            name: "nome",
            label: "Selecionadas",
            style: "width: 60%;",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerEmpresaMultiSelect(item),
      },
      dataSourceErro: {
        columns: [
          {
            name: "nome",
            label: "Nome",
          },
          {
            name: "size",
            label: "Tamanho",
          },
          {
            name: "extensao",
            label: "Extensão",
          },
          {
            name: "error",
            label: "Erro",
            classes: this.isAnexoSemErros ? "" : "is-invisible",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerAnexo(item),
      },
      dataSourceErroPermissao: {
        columns: [
          {
            name: "fase.ordem",
            label: "Ordem",
          },
          {
            name: "fase.nome",
            label: "Fase",
          },
          {
            name: "nomeResponsavel",
            label: "Responsavel",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerAnexo(item),
      },

      dataSourceErroPermissaoTarefaCliente: {
        columns: [
        {
            name: "nomeEmpresa",
            label: "Empresa",
          },
          {
            name: "nomeResponsavel",
            label: "Responsavel",
          },
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerAnexo(item),
      },
      tarefaRecebida: [],
      showModalDefinicaoPeriodoVigencia: false,
      isEdicaoConverteParaParcela: false,
      tiposDeTrimestres: [
        {
          value: 1,
          label: "1° trimestre",
        },
        {
          value: 2,
          label: "2° trimestre",
        },
        {
          value: 3,
          label: "3° trimestre",
        },
        {
          value: 4,
          label: "4° trimestre",
        },
      ],
      tiposDeSemestres: [
        {
          value: 1,
          label: "1° semestre",
        },
        {
          value: 2,
          label: "2° semestre",
        },
      ],
      trimestreSelected: null,
      semestreSelected: null,
      isToolbarTextEditorLoading: true,
      tiposDeDecendios: [
        {
          value: 1,
          label: "1° decêndio",
        },
        {
          value: 2,
          label: "2° decêndio",
        },
        {
          value: 3,
          label: "3° decêndio",
        },
      ],
      listagemFases: [],
      desabilitarSelectRecorrencia: false,
      checkFase: false,
      trechosBaixasPersonalizadas: [],
      loadingTrechosBaixasPersonalizadasDocumentos: true,
      loadingResponsaveisTarefaCliente: [],
      empresasSemPermissao: [],
      departamentosSemPermissao: [],
      isTemPermissaoParaEmpresasEDepartamentos: false,
      isFaseVazia: false,
      extensoesAnexoPermitidas: [
        "bmp",
        "doc",
        "dot",
        "jpg",
        "pdf",
        "png",
        "xls",
        "odt",
        "odf",
        "rtf",
        "txt",
        "xml",
        "html",
        "gif",
        "zip",
        "rar",
        "xlsx",
        "docx",
        "ppt",
        "pptx",
        "7z",
        "jpeg",
        "htm",
        "csv",
        "qrp",
        "tdm",
        "ofx",
        "ofc",
      ],
      arrayAnexosNaoPermitidos: [],
      dadosTabelaErro: [],
      isAnexoSemErros: false,
      anexosComErros: false,
      anexosCadastro: [],
      buscaEmpresaTabela: "",
      modalPermissaoAtivo: false,
      modalGruposTarefaVinculados: false,
      modalGruposTarefaVinculadosParceladas: false,
      errosDePermissao: [],
      deveConcederPermissaoAoSalvar: false,
      listaUsuariosClientes: [],
      listaResponsaveisClientesOptions: [],
      listaDeResponsaveisPorEmpresa: [],
      opcaoResponsavelSelecionada: [],
      complementoTarefaResponsaveisTarefaCliente: [],
      isOrdemFaseInvalida: false,
      pagina: 1,
      total: 0,
      limite: 10,
      modeloSelecionado: null,
      isSelectModeloOpen: false,
      modeloImportado: false,
      tooltipVisible: false,
      modeloCadastro: new ModeloDeTarefaModel(),
      deveCadastrarModelo: false,
      errosDePermissaoCadastroDeModelo: [],
      pessoaLogada: pessoaLogada.current,
      mensagemDeErroNomeModelo: '',
      removerTarefasParceladasDoGrupo: true,
      atributosCadastro :{
        departamentoId: null
      },
      descricao: {
        maxLength: 5000,
        plainText: ''
      },
      ajustarVencimentoDiasNaoUteis: false,
      opcoesAjusteVencimento: [
        {
          id: 'radio-antecipar-vencimento',
          label: 'Antecipar',
          valor: tipoAjusteVencimentoEnum.ANTECIPAR
        },
        {
          id: 'radio-prorrogar-vencimento', 
          label: 'Prorrogar',
          valor: tipoAjusteVencimentoEnum.PRORROGAR
        }
      ],
      diasDaSemanaOptions: diaDaSemanaEnum.listarDiasDaSemana()
    };
  },
  methods: {
    setRecorrencia(valor) {
      this.tarefa.recorrenciaId = valor;

      if(this.isSemanal || this.isAnual) {
        this.tarefa.tipoPrazoEntregaFinalId = null;
        this.tarefa.tipoPrazoEntregaLegalId = null;
      }
      
      if(valor) {
        this.limparDadosAoTrocarARecorrencia();
        this.listarCompetencias(this.tarefa.recorrenciaId);
      }
    },
    setRecorrenciaSelect(valor) {
      this.setRecorrencia(valor);
      this.$refs.selectRecorrencia.iniciarSelectComValor(valor);
    },
    setDiaDaSemana(valor) {
      this.diaPrazoEntregaFinal = valor;
      this.diaPrazoEntregaLegal = valor;

      if(valor == diaDaSemanaEnum.SABADO.getId()) {
        this.tarefa.isSabadoDiaUtil = true;
      }
    },
    doChangeDescricao(value) {
      const plainText = this.$refs.textEditor.getValueAsText();
      if(plainText.length > this.descricao.maxLength) {
        return;
      }

      this.tarefa.descricao = value;
      this.descricao.plainText = plainText;
    },

    async setDescricaoTarefa(value) {
      this.tarefa.descricao = value;
      if(!this.$refs.textEditor) return;
      this.$refs.textEditor.iniciarTextEditorComValor(value);
      await this.$nextTick();
      this.descricao.plainText = this.$refs.textEditor.getValueAsText();
    },

    textEditorAberto(e) {
      this.isToolbarTextEditorLoading = e;
      this.$refs.textEditor.iniciarTextEditorComValor(
        this.tarefa.descricao
      );
    },
    atribuirValorDepartamento(value) {
      this.tarefa.departamentoId = value;
      this.atributosCadastro.departamentoId = value;
    },

    atribuirValorResponsavel(value) {
      this.tarefa.responsavelId = value;
    },
    
    definirOrdemFaseInvalida(valor) {
      this.isOrdemFaseInvalida = valor;
    },
    executarSaveModal() {
      if (this.modalPermissaoAtivo) {
        this.ativarConcederPermissaoEChamarCadastro();
      } else if (this.modalGruposTarefaVinculadosParceladas && this.modalGruposTarefaVinculados) {
        this.toggleModoParcela(true)
        this.fecharModalParceladas();
      } else if (this.modalGruposTarefaVinculados) {
        this.ativarModalDefinicaoEFecharModalGrupo();
      } else if (this.showModalDefinicaoPeriodoVigencia) {
        this.verificarSeEParaCadastrarOuEditarTarefa();
      } else {
        this.validarPermissoesDeUsuarios();
      }
    },
    async adquirirServiceDePermissao() {
      const { permissaoService } = await import(
        "../../service/permissao-service"
      );
      return permissaoService;
    },
    renderErrorMessage(item, type) {
      return item?.parcelamento?.validacao[type]?.msg;
    },
    getParcelamentoValidoTemplate(item, type) {
      return item?.parcelamento?.validacao[type]?.isValid;
    },
    validarLinhaParcela(e, campoAlterado, item, isLoop = false) {
      if (campoAlterado == "atual") {
        if (!item?.parcelamento || !item?.parcelamento?.parcelaAtual) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg = "Campo obrigatório";
        } else if (
          parseInt(item.parcelamento.parcelaAtual) >
          parseInt(item.parcelamento.parcelaFinal)
        ) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg =
            "Parcela atual deve ser menor que a final";
          if (!isLoop) {
            this.validarLinhaParcela(e, "final", item, true);
          }
        } else if (item.parcelamento.parcelaAtual == 0) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg =
            "Parcela não pode ser igual a 0";
        } else {
          item.parcelamento.validacao[campoAlterado].isValid = true;
          item.parcelamento.validacao[campoAlterado].msg = "";
          if (!isLoop) {
            this.validarLinhaParcela(e, "final", item, true);
          }
        }
      }
      if (campoAlterado == "final") {
        if (!item?.parcelamento || !item?.parcelamento?.parcelaFinal) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg = "Campo obrigatório";
        } else if (
          parseInt(item.parcelamento.parcelaAtual) >
          parseInt(item.parcelamento.parcelaFinal)
        ) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg =
            "Parcela final deve ser maior que a atual";
          if (!isLoop) {
            this.validarLinhaParcela(e, "atual", item, true);
          }
        } else if (item.parcelamento.parcelaFinal == 0) {
          item.parcelamento.validacao[campoAlterado].isValid = false;
          item.parcelamento.validacao[campoAlterado].msg =
            "Parcela não pode ser igual a 0";
        } else {
          item.parcelamento.validacao[campoAlterado].isValid = true;
          item.parcelamento.validacao[campoAlterado].msg = "";
          if (!isLoop) {
            this.validarLinhaParcela(e, "atual", item, true);
          }
        }
      }
    },
    toggleModoParcela(event) {
      this.bloquearOuDesbloquearSelectDeRecorrencia(event);
      this.toggleCamposParcelaTabela(event);
      this.atualizarNomesEmpresasTabelaParcelada(event);
    },
    atualizarNomesEmpresasTabelaParcelada(event) {
      const empresasAtualizadas = this.dataSource.itens.map((linha) => {
        const empresa = this.listaEmpresas.find(
          (empresa) => linha.id == empresa.value
        );
        linha.nome = event ? truncateText(empresa.label, 25) : empresa.label;
        return linha;
      });

      this.dataSource.itens = empresasAtualizadas;
    },
    toggleCamposParcelaTabela(event) {
      let configuracao;
      if (event) {
        configuracao = [
          {
            name: "nome",
            label: "Selecionadas",
            style: "width: 40%;",
          },
          {
            name: "aPartirDaParcela",
            label: "A partir da parcela",
            slot: true,
            style: "width: 25%;",
          },
          {
            name: "divisor",
            label: "/",
            slot: true,
            style: "width: 1%;",
          },
          {
            name: "quantidadeTotal",
            label: "Qtd. total",
            slot: true,
            style: "width: 17%;",
          },
        ];
      } else {
        configuracao = [
          {
            name: "nome",
            label: "Selecionadas",
            style: "width: 60%;",
          },
        ];
      }
      this.dataSource.columns = configuracao;
    },
    bloquearOuDesbloquearSelectDeRecorrencia(event) {
      const isBloqueado = event;
      this.limparDadosAoTrocarARecorrencia();
      if (isBloqueado) {
        this.setRecorrenciaSelect(recorrenciaEnum.MENSAL);
      } else {
        this.$refs.selectRecorrencia.limparSelect();
        this.$refs.selectCompetencia.limparSelect();
        this.$refs.selectCompetencia.limparValidacao();
        this.desabilitarSelectCompetencias = true;
        this.tarefa.recorrenciaId = "";
      }
      this.desabilitarSelectRecorrencia = isBloqueado;
    },
    valorSelecionadoSelectAPatirDe(opcaoSelecionada) {
      if (this.isTrimestral) {
        this.trimestreSelected = opcaoSelecionada;
      } else if (this.isSemestral) {
        this.semestreSelected = opcaoSelecionada;
      } else if (this.isDecendial) {
        this.tarefa.tipoDecendio = opcaoSelecionada;
      }
    },
    listarOpcoesSelectAPatirDeAcordoComRecorrenciaSelecionada() {
      if (this.isTrimestral) {
        return this.tiposDeTrimestres;
      } else if (this.isSemestral) {
        return this.tiposDeSemestres;
      } else if (this.isDecendial) {
        return this.tiposDeDecendios;
      }
    },
    selecionarEmpresa(id) {
      if (!id) return;
      let empresa = this.listaEmpresas.find((e) => e.value === id);
      this.dataSource.itens.push(this._getEmpresaObj(empresa));
      utils.ordenarDeFormaCrescente(this.dataSource.itens);
      this.tarefa.empresasIds.push(id);
      if (this.dataSource.itens.length > 0) this.campoVazio = false;
    },
    async buscarResponsaveisParaEmpresaSelecionada(empresaId) {
      this.loadingResponsaveisTarefaCliente[empresaId] = true;
      let isEmpresaExistente = this.isEmpresaExistente(empresaId);

      if(!isEmpresaExistente) {
        let usuarios = await usuarioEmpresaService.listarUsuariosClienteComPermissaoParaAEmpresa(empresaId);
        this.listaUsuariosClientes = [...this.listaUsuariosClientes, ...usuarios];
      }

      this.listaResponsaveisClientesOptions[empresaId] = this.listaUsuariosClientes.find((e) => e.empresaId === empresaId)?.usuarios;
      this.loadingResponsaveisTarefaCliente[empresaId] = false;
    },
    isEmpresaExistente(empresaId) {
      return this.listaUsuariosClientes.find((e) => e.empresaId === empresaId);
    },
    atualizarComplementoTarefaCliente(empresaId, responsavelId) {
      if (!this.isTarefaCliente) return;
      const responsavelPorEmpresa = {
        empresaId: empresaId,
        responsavelId: !responsavelId ? null : parseInt(responsavelId),
      };
      
      this.removerEmpresaDoComplementoDaTarefa(empresaId)
      
      if(this.complementoTarefaResponsaveisTarefaCliente) {
        this.listaDeResponsaveisPorEmpresa = [...this.complementoTarefaResponsaveisTarefaCliente];
      }
      this.listaDeResponsaveisPorEmpresa.push(responsavelPorEmpresa);
      this.complementoTarefaResponsaveisTarefaCliente = this.listaDeResponsaveisPorEmpresa;
    },
    removerEmpresaDoComplementoDaTarefa(empresaId) {
      if (!this.isTarefaCliente) return;
      let empresaExistenteNoComplemento = this.complementoTarefaResponsaveisTarefaCliente?.find((e) => e.empresaId  == empresaId);
      
      if(empresaExistenteNoComplemento) {
        this.complementoTarefaResponsaveisTarefaCliente = this.complementoTarefaResponsaveisTarefaCliente.filter(objeto => objeto.empresaId !== empresaId);
      }
    },
    selecionarCategoria(id) {
      if (!id) return;
      let empresa = this.listaEmpresas.find((e) => e.value === id);
      this.dataSource.itens.push(this._getEmpresaObj(empresa));
      utils.ordenarDeFormaCrescente(this.dataSource.itens);
      if (this.dataSource.itens.length > 0) this.campoVazio = false;
    },

    removerCategoria(id) {
      this.dataSource.itens = this.dataSource.itens.filter((x) => x.id != id);
    },

    selecionarTodasAsEmpresas() {
      this.dataSource.itens = this.listaEmpresas.map(this._getEmpresaObj);
      this.dataSource.itens = this.dataSource.itens.concat(this.empresas.semAcesso);

      this.empresas.selecionadas = this.dataSource.itens.map(e => e.id);
      this.tarefa.empresasIds = this.empresas.semETarefas.map(e => e.id).concat(this.empresas.selecionadas);

      utils.ordenarDeFormaCrescente(this.dataSource.itens);
      if (this.dataSource.itens.length > 0) this.campoVazio = false;
    },

    removerEmpresa(id) {
      this.dataSource.itens = this.dataSource.itens.filter((x) => x.id != id);
      this.tarefa.empresasIds = this.tarefa.empresasIds.filter(i => i != id);
      this.removerEmpresaDoComplementoDaTarefa(id);
    },

    removerTodasAsEmpresas() {
      this.dataSource.itens = [ ...this.empresas.semAcesso ];
      this.empresas.selecionadas = this.dataSource.itens.map(e => e.id);
      utils.ordenarDeFormaCrescente(this.dataSource.itens);

      const ids = this.dataSource.itens.map(e => e.id);
      this.tarefa.empresasIds = ids.concat(this.empresas.semETarefas.map(e => e.id));
    },

    removerEmpresaMultiSelect(item) {
      try {
        this.$refs.multiselect.deselect(item.id);
      } catch (error) {
        toastUtils.dangerToast(
          "Este usuário não tem permissão para excluir esta empresa"
        );
      }
    },

    removerAnexo(item) {
      this.tarefa.anexo = this.tarefa.anexo.filter((x) => x.nome != item.nome);
      this.dataSourceErro.itens = this.dataSourceErro.itens.filter(
        (x) => x.nome != item.nome
      );
      this.anexosCadastro = this.anexosCadastro.filter(
        (x) => x.nome != item.nome
      );
    },

    async listarRecorrencias() {
      if (this.listaRecorrenciaECompetencia.length > 0) {
        this.recorrencias = this.listaRecorrenciaECompetencia.map((element) => {
          return {
            value: element.id,
            label: element.descricao,
          };
        });
      }
      return this.recorrencias;
    },

    async listarCompetencias(value) {
      this.diaPrazoEntregaFinal = "1";
      this.diaPrazoEntregaLegal = "1";
      this.desabilitarSelectCompetencias = true;

      if (this.listaRecorrenciaECompetencia.length > 0) {
        let listaDeCompetencias = this.listaRecorrenciaECompetencia.find(
          (obj) => obj.id === value
        ).competencias;
        this.competencias = listaDeCompetencias.map((element) => {
          return {
            value: element.id,
            label: element.descricao,
          };
        });
        this.desabilitarSelectCompetencias = false;
      }

      return this.competencias;
    },

    geradorDeDias() {
      if (!this.diasPrazoEntrega.length) {
        for (let i = 1; i <= 30; i++) {
          this.diasPrazoEntrega.push({
            value: ("00" + i).slice(-2),
            label: ("00" + i).slice(-2),
          });
        }
      }
      return this.diasPrazoEntrega;
    },

    validarCamposVaziosPrazoLegalMensal() {      
      if (this.isTarefaCliente || this.ultimoDiaPrazoEntregaLegal) return;
      
      var camposVerificados = [];

      var diaPrazoLegal =
        this.$refs.inputDiaPrazoEntregaLegal.verificarSeInputEstaVazio(
          this.diaPrazoEntregaLegal
        );
      var mesPrazoLegal =
        this.$refs.selectMesPrazoEntregaLegal.verificarSeInputEstaVazio();

      if (diaPrazoLegal || mesPrazoLegal) this.labelPrazoLegal = true;
      else this.labelPrazoLegal = false;

      camposVerificados.push(diaPrazoLegal, mesPrazoLegal);
      return camposVerificados;
    },
    validarCamposVaziosPrazoFinalMensal() {
      if (this.ultimoDiaPrazoEntregaFinal) return;

      var camposVerificados = [];

      var diaPrazoFinal =
        this.$refs.inputDiaPrazoEntregaFinal.verificarSeInputEstaVazio(
          this.diaPrazoEntregaFinal
        );
      var mesPrazoFinal =
        this.$refs.selectMesPrazoEntregaFinal.verificarSeInputEstaVazio();

      if (diaPrazoFinal || mesPrazoFinal) this.labelPrazoFinal = true;
      else this.labelPrazoFinal = false;

      camposVerificados.push(diaPrazoFinal, mesPrazoFinal);
      return camposVerificados;
    },

    atualizarCamposDosSelectsDeDiaETipoDePrazoEntregaFinal(event) {
      const isBloqueado = event;

      if(isBloqueado) {
        this.$refs.selectMesPrazoEntregaFinal.limparSelect();
        this.$refs.selectMesPrazoEntregaFinal.limparValidacao();
        this.diaPrazoEntregaFinal = "";
        this.$refs.inputDiaPrazoEntregaFinal.limparValidacao();
        this.labelPrazoFinal = false;
      }
    },

    atualizarCamposDosSelectsDeDiaETipoDePrazoEntregaLegal(event) {
      const isBloqueado = event;

      if(isBloqueado) {
        this.$refs.selectMesPrazoEntregaLegal.limparSelect();
        this.$refs.selectMesPrazoEntregaLegal.limparValidacao();
        this.diaPrazoEntregaLegal = "";
        this.$refs.inputDiaPrazoEntregaLegal.limparValidacao();
        this.labelPrazoLegal = false;
      }
    },

    recorrenciasComSelectAPatirDe() {
      return (
        this.isTrimestral ||
        this.isSemestral ||
        this.isDecendial
      );
    },

    recorrenciasQueEnviamOsDiasDosPrazoDeEntregaELegal() {
      return (
        this.isTrimestral ||
        this.isSemestral ||
        this.isDecendial ||
        this.isSemanal
      );
    },

    validacaoCamposVazios() {
      var camposVerificados = [];
      var camposValido = true;
      var verificar = [];

      verificar.push(this.$refs.inputNome.verificarSeInputEstaVazio());
      verificar.push(this.$refs.selectDepartamento.verificarSeInputEstaVazio());

      if (!this.isTarefaAvulsa) {
        verificar.push(
          this.$refs.selectRecorrencia.verificarSeInputEstaVazio()
        );
        verificar.push(
          this.$refs.selectCompetencia.verificarSeInputEstaVazio()
        );
      }

      if (this.recorrenciasComSelectAPatirDe()) {
        verificar.push(!!!this.aPartirDe);
        verificar.push(this.$refs.selectAPartirDe.verificarSeInputEstaVazio());
        verificar.push(
          this.$refs.inputApartirDeComSelect.verificarSeInputEstaVazio()
        );
      } else if (!this.isTarefaAvulsa) {
        verificar.push(this.$refs.inputApartirDe.verificarSeInputEstaVazio());
      }
      if (
        this.isMensal ||
        this.recorrenciasComSelectAPatirDe()
      ) {        
        camposVerificados = verificar
          .concat(this.validarCamposVaziosPrazoLegalMensal())
          .concat(this.validarCamposVaziosPrazoFinalMensal());
      } else {
        if (
          !this.isTarefaCliente &&
          !this.isSemanal
        ) {
          verificar.push(
            this.$refs.inpuPrazoEntregaLegal.verificarSeInputEstaVazio()
          );
        }
        if (this.isTarefaCliente) {
          verificar.push(
            this.$refs.textEditorLayoutNotificacao.verificarSeTextEditorEstaVazio()
          );
        }

        if (this.isSemanal) {
          verificar.push(
            this.$refs.selectDiaDaSemanaPrazoEntregaFinal.verificarSeInputEstaVazio()
          );
        } else {
          verificar.push(
            this.$refs.inpuPrazoEntrega.verificarSeInputEstaVazio()
          );
        }
        camposVerificados = verificar;
      }

      this.verificarSelectResponsavel();

      camposVerificados.map((campo) => {
        if (campo) return (camposValido = false);
      });

      if (this.checkFase && this.listagemFases.length == 0) {
        this.isFaseVazia = true;
      }

      if (this.isTarefaCliente) {
        this.$refs.selectCategoria.verificarSeInputEstaVazio();
      }

      return camposValido;
    },
    resetarCamposDePermissoes() {
      this.modalPermissaoAtivo = false;
      this.errosDePermissao = [];
      this.deveConcederPermissaoAoSalvar = false;
    },
    montarListagemErrosDePermissao(falhasDePermissao) {
      if (!Array.isArray(falhasDePermissao)) {
        return [];
      }
      const listaOrdenada = [];
      falhasDePermissao.forEach((falha) => {
        if (
          !listaOrdenada.some((item) => {
            const isOrdemMatch = falha.fase.ordem == item.fase.ordem;
            const isNomeMatch = falha.fase.nome == item.fase.nome;
            const isResponsavelMatch =
              falha.nomeResponsavel == item.nomeResponsavel;
            return isOrdemMatch && isNomeMatch && isResponsavelMatch;
          })
        ) {
          listaOrdenada.push(falha);
        }
      });
      listaOrdenada.sort((a, b) => {
        if (a.fase.ordem < b.fase.ordem) {
          return -1;
        } else {
          return true;
        }
      });

      return listaOrdenada;
    },
    async validarPermissoesDeUsuarios() {

      this.atribuirValoresInseridosAoObjetoTarefa();
      if (
        this.isCamposVaziosNaAbaDeCadastroEVinculoDeEmpresas() ||
        this.isAnexosComErros()
      ) {
        return;
      }
      if (!this.checkFase && !this.isTarefaCliente) {
        this.modalGruposTarefaVinculados = this.deveExibirModalGruposTarefasVinculados();

        this.showModalDefinicaoPeriodoVigencia =
          this.showModalDefinicaoPeriodoDeVigencia();
        if (!this.modalGruposTarefaVinculados) {
          this.verificarSeEParaCadastrarOuEditarTarefa();
        }
        return;
      }
      this.isBtnLoading = true;
      this.resetarCamposDePermissoes();
      try {
        const permissaoService = await this.adquirirServiceDePermissao();
        const tarefaProxy = Object.assign({}, this.tarefa);
        const validacoesDePermissao = await permissaoService.verificarPermissao(
          tarefaProxy
        );    
        this.errosDePermissao = this.montarListagemErrosDePermissao(
          validacoesDePermissao
        );
        const temErrosDePermissao = this.errosDePermissao.length > 0;
        this.showModalDefinicaoPeriodoVigencia =
          this.showModalDefinicaoPeriodoDeVigencia();

        this.modalGruposTarefaVinculados = this.deveExibirModalGruposTarefasVinculados();

        if (temErrosDePermissao) {
          this.modalPermissaoAtivo = true;
          this.tituloModal = "Conceder permissão";
          this.isBtnLoading = false;
        } else if (this.modalGruposTarefaVinculados) {
          this.modalPermissaoAtivo = false;
          this.isBtnLoading = false;
          this.showModalDefinicaoPeriodoVigencia = false;
        } else if (this.showModalDefinicaoPeriodoVigencia) {
          this.modalPermissaoAtivo = false;
          this.isBtnLoading = false;
          this.modalGruposTarefaVinculados = false;
          this.verificarSeEParaCadastrarOuEditarTarefa();
          return;
        } else {
          this.verificarSeEParaCadastrarOuEditarTarefa();
        }
      } catch (e) {
        console.warn(e);
        this.isBtnLoading = false;
      }
    },
    ativarConcederPermissaoEChamarCadastro() {
      this.deveConcederPermissaoAoSalvar = true;
      if (this.modalGruposTarefaVinculados) {
        this.modalPermissaoAtivo = false;
        this.showModalDefinicaoPeriodoVigencia = false;
        this.isBtnLoading = false;
        return;
      }
      if (this.showModalDefinicaoPeriodoVigencia) {
        this.modalGruposTarefaVinculados = false;
        this.modalPermissaoAtivo = false;
        this.isBtnLoading = false;
      }
      this.verificarSeEParaCadastrarOuEditarTarefa();
    },
    ativarModalDefinicaoEFecharModalGrupo() {
      if (this.showModalDefinicaoPeriodoVigencia) {
        this.modalGruposTarefaVinculados = false;
        this.modalPermissaoAtivo = false;
        this.isBtnLoading = false;
      }
      this.verificarSeEParaCadastrarOuEditarTarefa();
    },
    fecharModalParceladas() {
      this.modalGruposTarefaVinculados = false;
      this.removerTarefasParceladasDoGrupo = true;
    },
    fecharModal() {
      if (this.modalPermissaoAtivo || (this.modalGruposTarefaVinculados && this.tarefa.parcelada)) {
        this.showModalDefinicaoPeriodoVigencia = false;
        this.modalGruposTarefaVinculados = false;
        this.modalGruposTarefaVinculadosParceladas = false;
        this.resetarCamposDePermissoes();
        this.removerTarefasParceladasDoGrupo = false;
        this.resetarValoresAposFecharModalGruposComTarefasParceladas();
      } else {
        this.limparInputsPreenchidosAoFecharModal();
        this.$emit("trf-close-modal-cadastro");
      }
    },
    resetarValoresAposFecharModalGruposComTarefasParceladas() {
      if(!this.removerTarefasParceladasDoGrupo) {
        this.tarefa.parcelada = false;
      }
    },
    verificarSeEParaCadastrarOuEditarTarefa() {
      if (this.edicao) {
        this.editarTarefa();
      } else {
        this.cadastrarNovaTarefa();
      }
    },

    editarTarefa() {
      try {
        if (!this.showModalDefinicaoPeriodoVigencia) {
          this.editarTarefaSemPeriodoDeVigencia();
          return;
        }

        if (this.isDefinicaoDoPeriodoDeVigenciaNecessaria) {
          this.editarTarefaComPeriodoDeVigencia();
          return;
        }

        this.tituloModal = "Definição do período de vigência:";
        this.isDefinicaoDoPeriodoDeVigenciaNecessaria = true;
      } catch (e) {
        console.warn(e);
        toastUtils.dangerToast(
          "Ocorreu um erro ao cadastrar a tarefa. Favor cadastre novamente"
        );
        this.isBtnLoading = false;
      }
    },
    async concederPermissaoParaTarefaAtual() {
      const permissaoService = await this.adquirirServiceDePermissao();
      const tarefaProxy = Object.assign({}, this.tarefa);
      const concederPermissoes = await permissaoService.atualizarPermissao(
        tarefaProxy
      );
    },

    async editarTarefaComPeriodoDeVigencia() {
      try {
        if (
          this.$refs.dataDeVigencia.verificarSeInputDoTipoDateEstaVazio() ||
          !this.$refs.dataDeVigencia.verificarSeDataEValida()
        )
          return;
        if (
          this.verificarSeFaseFoiAlterada() &&
          this.isDataDeVigenciaMenorQueADataDeHoje()
        ) {
          return;
        } else if (
          !this.verificarSeFaseFoiAlterada() &&
          this.isDataDeVigenciaMenorQueAPartirDaTarefa()
        ) {
          return;
        }
        this.isBtnLoading = true;
        this.tarefa.dataDeVigencia = this.dataDeVigencia;
        if (this.deveConcederPermissaoAoSalvar) {
          await this.concederPermissaoParaTarefaAtual();
        }

        await service.editarTarefa(this.tarefa);
      } catch (e) {
        toastUtils.dangerToast(
          "Ocorreu um erro ao editar a tarefa. Favor tente novamente"
        );
        this.isBtnLoading = false;
      }
    },

    async editarTarefaSemPeriodoDeVigencia() {
      try {
        this.isBtnLoading = true;
        if (this.deveConcederPermissaoAoSalvar) {
          await this.concederPermissaoParaTarefaAtual();
        }
        
        await service.editarTarefa(this.tarefa);
      } catch (e) {
        toastUtils.dangerToast(
          "Ocorreu um erro ao editar a tarefa. Favor tente novamente"
        );
        this.isBtnLoading = false;
      }
    },

    async cadastrarNovaTarefa() {
      try {
        this.atribuirValoresInseridosAoObjetoTarefa();

        if (this.isAnexosComErros()) return;
        this.isBtnLoading = true;

        if (this.tarefa.responsavelId) {
          const responsavel = await usuarioService.getResponsavel(
            this.tarefa.responsavelId
          );
          this.verificaPermissoesDoUsuario(responsavel);
        }

        if (
          this.departamentosSemPermissao.length == 0 &&
          this.empresasSemPermissao.length == 0
        ) {
          this.isTemPermissaoParaEmpresasEDepartamentos = true;
        }
        if (this.deveConcederPermissaoAoSalvar) {
          await this.concederPermissaoParaTarefaAtual();
        }
        
        this.preencherDadosModelo();
        if (await this.validarCadastroModelo()) {
          await this.cadastrarModelo();
        }

        const response = await service.post(
          this.tarefa,
          this.isTemPermissaoParaEmpresasEDepartamentos
        );
        if (!this.isTemPermissaoParaEmpresasEDepartamentos) {
          if (response.ok) {
            this.$emit("verificaRequisicao", true);
          }
        }

        if (!this.hasRecorrencia) {
          telemetriaService.cadastrarTelemetria("tarefas");
        }
      } catch (e) {
        console.error(e);
        toastUtils.dangerToast(
          "Ocorreu um erro ao cadastrar a tarefa. Favor cadastre novamente"
        );
        this.isBtnLoading = false;
      }
    },

    isCamposVaziosNaAbaDeCadastroEVinculoDeEmpresas() {
      if (!this.validacaoCamposVazios()) {
        toastUtils.dangerToast("Campo obrigatório!");

        if (this.tarefa.nome.length > 1) {
          this.classAjustarEspacamentoSwitcher =
            "posicao-switcher-status-tarefa";
        }
        this.classAjustarEspacamentoSwitcher =
          "posicao-switcher-status-tarefa-validacao-campos";
        document.getElementById("tab-cadastro").click();
        return true;
      } else if (
        this.dataSource.itens == undefined ||
        this.dataSource.itens.length < 1
      ) {
        this.campoVazio = true;
        document.getElementById("tab-vinculo-empresas").click();
        return true;
      } else if (this.tarefa.parcelada && !this.isParcelasPreenchidas()) {
        document.getElementById("tab-vinculo-empresas").click();
        return true;
      } else if (
      (this.isTarefaCliente &&
        (this.tarefa.textoLayoutNotificacao == undefined ||
          this.tarefa.textoLayoutNotificacao == "" ||
          this.tarefa.textoLayoutNotificacao == null ||
          this.idCategoriaDaTarefa == undefined ||
          this.idCategoriaDaTarefa == null))
      ) {
        document.getElementById("tab-informacoes-adicionais").click();
        return true;
      } else if (
        this.checkFase && this.listagemFases.length == 0
      ) {
        document.getElementById("tab-fase").click();
        toastUtils.dangerToast(
          "Adicione fases em sua tarefa."
        );
        return true;
        } else if (this.listagemFases.length > 0 && this.isOrdemFaseInvalida) {
          document.getElementById("tab-fase").click();
          toastUtils.dangerToast(
              "As fases devem ser cadastradas em sequência numérica. Verifique."
            );
          return true;
        } else {
        return false;
      }
    },

    isAnexosComErros() {
      if (this.dataSourceErro.itens.length > 0) {
        this.anexosComErros = this.dataSourceErro.itens.some((obj) =>
          obj.hasOwnProperty("error")
        );
        if (this.anexosComErros) {
          toastUtils.dangerToast(
            "Existe um ou mais arquivos não permitidos. Verifique!"
          );
          this.isBtnLoading = false;
        }
      }
      return this.anexosComErros;
    },

    isParcelasPreenchidas() {
      if (!this.tarefa?.parcelada) return true;

      return this.dataSource.itens.every((empresa) => {
        const isValid =
          empresa.parcelamento.validacao.atual.isValid &&
          empresa.parcelamento.validacao.final.isValid;
        if (!isValid) {
          this.validarLinhaParcela(null, "atual", empresa);
        }
        return isValid;
      });
    },

    atribuirValoresInseridosAoObjetoTarefa() {
      this.definirCategoriaDaTarefa();

      this.tarefa.tipoDeTarefaId = tipoTarefaEnum.AVULSA;
      if (!this.isTarefaAvulsa) {
        this.tarefa.aPartirDe = this.formatarData(this.aPartirDe);
        if (
          this.isAnual ||
          this.isSemanal
        ) {
          this.tarefa.tipoPrazoEntregaLegalId = tipoPrazoDeEntregaEnum.DIA_FIXO.getId();
          this.tarefa.tipoPrazoEntregaFinalId = tipoPrazoDeEntregaEnum.DIA_FIXO.getId();
        }
        this.tarefa.tipoDeTarefaId = tipoTarefaEnum.COMUM;
      } else {
        this.tarefa.deveNotificarResponsavelTarefaAvulsa = this.deveNotificarResponsavelTarefaAvulsa;
      }
      if (this.prazoLegal && this.prazoEntrega) {
        if(this.tarefa.aPartirDe != this.tarefaRecebida.aPartirDe || this.isTarefaAvulsa){
          this.tarefa.prazoLegal = this.formatarData(this.prazoLegal);
          this.tarefa.prazoEntrega = this.formatarData(this.prazoEntrega);
        }else{
          const anoPrazoEntrega =  this.tarefaRecebida.prazoEntrega.substr(0,4);
          const anoPrazoLegal =  this.tarefaRecebida.prazoLegal.substr(0,4);
          this.tarefa.prazoLegal = this.formatarDataComAno(this.prazoLegal, anoPrazoLegal);
          this.tarefa.prazoEntrega = this.formatarDataComAno(this.prazoEntrega, anoPrazoEntrega);
        }
      } else if (this.prazoEntrega && this.isTarefaCliente) {
        this.tarefa.prazoLegal = this.formatarData(this.prazoEntrega);
        this.tarefa.prazoEntrega = this.formatarData(this.prazoEntrega);
      } else {
        if (this.recorrenciasQueEnviamOsDiasDosPrazoDeEntregaELegal()) {
          this.tarefa.inicioPrazoEntrega = this.diaPrazoEntregaFinal;
          this.tarefa.inicioPrazoLegal = this.diaPrazoEntregaLegal;
        } else {
          this.tarefa.prazoLegal = this.formatarData(this.diaPrazoEntregaLegal);
          this.tarefa.prazoEntrega = this.formatarData(
            this.diaPrazoEntregaFinal
          );
        }
      }
      this.tarefa.ativo = this.isTarefaAtiva;
      if (this.isTarefaCliente) {
        this.tarefa.tipoPrazoEntregaLegalId =
          this.tarefa.tipoPrazoEntregaFinalId;
        this.tarefa.prazoLegal = this.tarefa.prazoEntrega;
      }
      this.tarefa.statusId = this.statusId;
      this.tarefa.padrao = this.padrao;
      this.tarefa.geraMulta = this.geraMulta;

      if (this.tarefa.parcelada) {
        this.tarefa.complementoTarefa = {};
        this.tarefa.complementoTarefa.parcelamento =
          this.complementoTarefaParcelamento;
        this.tarefa.tipoDeTarefaId = tipoTarefaEnum.PARCELADA;
      }

      if (this.checkFase) {
        const objetoFase = this.listagemFases;

        this.tarefa.complementoTarefa.fases = objetoFase;

        this.tarefa.tipoDeTarefaId = this.isTarefaAvulsa? tipoTarefaEnum.AVULSAENCADEADA : tipoTarefaEnum.ENCADEADA;
      }

      if(this.isTarefaCliente) {
        this.tarefa.complementoTarefa.responsaveisTarefaCliente =
          this.complementoTarefaResponsaveisTarefaCliente;
      }

      this.tarefa.ultimoDiaPrazoEntregaLegal = this.ultimoDiaPrazoEntregaLegal;
      this.tarefa.ultimoDiaPrazoEntregaFinal = this.ultimoDiaPrazoEntregaFinal;
      
      if(this.ultimoDiaPrazoEntregaLegal || (this.isTarefaCliente && this.ultimoDiaPrazoEntregaFinal)) {
        this.tarefa.tipoPrazoEntregaLegalId = tipoPrazoDeEntregaEnum.DIA_UTIL.getId();
        let diaPrazoLegal = this.ultimoDiaPrazoEntregaLegal ? "01" : this.diaPrazoEntregaLegal;
        this.tarefa.prazoLegal = this.formatarData(diaPrazoLegal);
      }

      if(this.ultimoDiaPrazoEntregaFinal) {
        this.tarefa.tipoPrazoEntregaFinalId = tipoPrazoDeEntregaEnum.DIA_UTIL.getId();
        let diaPrazoEntrega = this.ultimoDiaPrazoEntregaFinal ? "01" : this.diaPrazoEntregaFinal;
        this.tarefa.prazoEntrega = this.formatarData(diaPrazoEntrega);
      }
    },

    definirCategoriaDaTarefa(){
      if(this.isTarefaCliente){
        let idCategoria = this.idCategoriaDaTarefa;
        let categoriaToFind = this.listaCategorias.find(function(element) {
          return element.value === idCategoria;
        });

        categoriaToFind = Object.assign({}, categoriaToFind);

        if (categoriaToFind.isPersonalizada) {
          this.tarefa.categoriaId = 99;
          this.tarefa.categoriaPersonalizada = categoriaToFind.label;
        }else{
          this.tarefa.categoriaId = categoriaToFind.value;
          this.tarefa.categoriaPersonalizada = "";
        }
      }
    },

    formatarData(data) {
      let dataFormatada = "";
      let mes = new Date().getMonth();
      const lengthPrazoEntregaLegalOuFinal = 5;
      const lengthAPatirDe = 7;

      if (data.length == 1) {
        data = "0" + data;
      }
      if (data.length == lengthPrazoEntregaLegalOuFinal) {
        const ano = this.isTarefaAvulsa
          ? new Date().getFullYear()
          : this.aPartirDe.substring(3);
        dataFormatada = data + "/" + ano;
      } else if (data.length == lengthAPatirDe) {
        dataFormatada = "01" + "/" + data;
      } else if (data.length == 10) {
        dataFormatada = data;
      } else {
        dataFormatada = data + "/" + this.aPartirDe;
      }
      dataFormatada = dataFormatada.split("/").reverse().join("-");
      return dataFormatada;
    },

    formatarDataComAno(data, ano) {
      let dataFormatada = "";
      const lengthPrazoEntregaLegalOuFinal = 5;
      const lengthAPatirDe = 7;

      if (data.length == 1) {
        data = "0" + data;
      }
      if (data.length == lengthPrazoEntregaLegalOuFinal) {
        dataFormatada = data + "/" + ano;
      } else if (data.length == lengthAPatirDe) {
        dataFormatada = "01" + "/" + data;
      } else if (data.length == 10) {
        dataFormatada = data;
      } else {
        dataFormatada = data + "/" + this.aPartirDe;
      }
      dataFormatada = dataFormatada.split("/").reverse().join("-");
      return dataFormatada;
    },

    limparInputsPreenchidosAoFecharModal() {
      this.tarefa.nome = "";
      this.aPartirDe = "";
      this.anoAPartirDe = "";
      this.prazoLegal = "";
      this.prazoEntrega = "";
      this.geraMulta = false;
      this.removerTodasAsEmpresas();
      this.classAjustarEspacamentoSwitcher = "posicao-switcher-status-tarefa";
      this.tarefa.recorrenciaId = "";
      this.desabilitarSelectCompetencias = true;
      this.isTarefaAtiva = true;
      this.deveNotificarResponsavelTarefaAvulsa = true;
      this.tabSelecionada = "";
      this.campoVazio = false;
      this.labelPrazoLegal = false;
      this.labelPrazoFinal = false;
      this.isDefinicaoDoPeriodoDeVigenciaNecessaria = false;
      this.diaPrazoEntregaFinal = "1";
      this.diaPrazoEntregaLegal = "1";
      this.tituloModal = "Editar tarefa";
      this.dataDeVigencia = null;
      this.tarefa.baixaPersonalizada = null;
      this.tarefa.descricao = "";
      this.tarefa.parcelada = false;
      this.tarefa.complementoTarefa = {};
      this.listagemFases = [];
      this.listagemResponsaveisTarefaCliente = [];
      this.isOrdemFaseInvalida = false;
      if (this.checkFase) {
        this.$refs.cadastroDeFases.limparCamposFase();
        this.$refs.cadastroDeFases.limparListagemFases();
      }
      this.resetarCamposDePermissoes();
      this.ultimoDiaPrazoEntregaLegal = false;
      this.ultimoDiaPrazoEntregaFinal = false;
      this.empresas = {
        semAcesso: [],
        semETarefas: [],
        selecionadas: []
      }
      this.dataSource.itens = [];
      
      this.setAjustarVencimento(false);
    },

    ajustarEspacamentoSwitcher() {
      if (this.tarefa.nome.trim().length < 1) {
        this.classAjustarEspacamentoSwitcher =
          "posicao-switcher-status-tarefa-validacao-campos";
      } else {
        this.classAjustarEspacamentoSwitcher = "posicao-switcher-status-tarefa";
      }
    },
    inicializarCamposNaEdicao(objeto) {
      this.tarefaRecebida = objeto;
      this.tarefa.tarefaCliente = this.isTarefaCliente;
      this.tarefa.tipoDeTarefaId = objeto.tipoDeTarefaId;
      this.setDescricaoTarefa(objeto.descricao);
      
      this.tarefa.desativarConclusaoManual = objeto.desativarConclusaoManual;
      if(this.$refs.checkboxConclusaoManual) {
        this.$refs.checkboxConclusaoManual.$refs.iptCheckbox.checked = this.tarefa.desativarConclusaoManual;
      }

      this.atributosCadastro.departamentoId = objeto?.departamento?.id;
      const isCategoriaPersonalizada = objeto?.categoriaId == 99;
      if (!isCategoriaPersonalizada && (!!objeto?.categoriaId  || objeto?.categoriaId == 0)) {
        this.idCategoriaDaTarefa  = this.$refs.selectCategoria.iniciarSelectComValor(objeto?.categoriaId?.toString());
      } else if (!!objeto?.categoriaPersonalizada) {
        this.idCategoriaDaTarefa = this.$refs.selectCategoria.iniciarSelectComValorBuscandoPorLabel(objeto?.categoriaPersonalizada);
      }
      
      this.inicializarEmpresas(objeto);

      if (!this.isTarefaCliente) {
        this.tarefa.responsavelId =
          this.$refs.selectResponsavel.iniciarSelectComValor(
            objeto.responsavelId
          );
      }
      this.isTarefaAtiva = objeto.ativo;
      this.tarefa.nome = objeto.nome;
      this.tarefa.id = objeto.id;
      
      this.tarefa.departamentoId =
        this.$refs.selectDepartamento.iniciarSelectComValor(
          !!objeto.departamentoPadrao && !!!objeto.departamento
            ? objeto.departamentoPadrao.id.toString()
            : objeto.departamento.id.toString()
        );

      this.inicializarCamposRelacionadosAosPrazos(objeto);

      this.geraMulta = objeto.geraMulta;
      this.tarefa.empresasIds = this.buscaIdsdasEmpresarCadastras(
        objeto.empresas
      );
      syncUtils.aguardaSincronia(() => {
        this.tarefa.baixaPersonalizada = objeto.baixaPersonalizada;
      });
      if (this.isTarefaCliente) {
        if (objeto.textoLayoutNotificacao == null) {
          this.tarefa.textoLayoutNotificacao =
            this.iniciarCampoLayoutNotificacaoComTextoDefault();
        } else {
          this.tarefa.textoLayoutNotificacao =
            this.$refs.textEditorLayoutNotificacao.iniciarTextEditorComValor(
              objeto.textoLayoutNotificacao
            );
        }
      }
      this.isEdicaoConverteParaParcela = !objeto.parcelada;
      if (objeto?.complementoTarefa?.fases != null) {
        this.inicilizarEdicaoFases(objeto);
      }

      this.tarefa.isSabadoDiaUtil = objeto.isSabadoDiaUtil;
      
      this.setTipoAjusteVencimentoId(objeto.tipoAjusteVencimentoId);
      this.setAjustarVencimento(objeto.tipoAjusteVencimentoId != null);

      this.$nextTick();
      this.inicializarEdicaoResponsaveisTarefaCliente(objeto);
      syncUtils.aguardaSincronia(() => {
        this.atribuirValoresAoSelectDeUsuariosDasEmpresas(objeto);
      }, 10);
    },

    inicializarEmpresas(objeto) {
      if (!objeto.empresas) {
        return;
      }

      const idsEmpresasValidas = this._getValues(this.listaEmpresas);
      const empresasValidas = objeto.empresas.filter(e => e.utilizaEtarefasWeb);
      
      this.dataSource.itens = empresasValidas.map(e => {
        return {
          id: e.id,
          nome: objeto.parcelada
            ? truncateText(`${e.externoId} - ${e.nome}`, 25)
            : (`${e.externoId} - ${e.nome}`),
          parcelamento: {
            empresaId: e.id,
            parcelaAtual: "1",
            parcelaFinal: "1",
            validacao: {
              atual: {
                isValid: true,
                msg: "",
                disabled: objeto.parcelada,
              },
              final: {
                isValid: true,
                msg: "",
                disabled: false,
              },
            },
          },
        }
      });

      utils.ordenarDeFormaCrescente(this.dataSource.itens);

      this.empresas.selecionadas = this.dataSource.itens.map(e => e.id);
      this.empresas.semETarefas = objeto.empresas.filter(e => !e.utilizaEtarefasWeb);
      this.empresas.semAcesso = this.dataSource.itens.filter(e => !idsEmpresasValidas.includes(e.id));
    },
    
    async inicializarCamposRelacionadosAosPrazos(objeto) {
      await this.$nextTick();

      this.aPartirDe = objeto.aPartirDe
        ? objeto.aPartirDe.substr(5, 2) + "/" + objeto.aPartirDe.substr(0, 4)
        : "";
     
      this.tarefa.recorrenciaId =
        this.$refs.selectRecorrencia.iniciarSelectComValor(
          objeto.recorrencia.id
        );

      this.tarefa.competenciaId =
        this.$refs.selectCompetencia.iniciarSelectComValor(
          objeto.competenciaId
      );

      await this.$nextTick();
      
      this.inicializarTarefaMensal(objeto);
      this.inicializarTarefaAnual(objeto);
      this.inicializarTarefaTrimestral(objeto);
      this.inicializarTarefaSemestral(objeto);
      this.inicializarTarefaDecendial(objeto);
      this.inicializarTarefaParcelada(objeto);
      this.inicializarTarefaSemanal(objeto);

      this.prepararCamposUltimoDiaUtil(objeto);
    },

    async prepararCamposUltimoDiaUtil(objeto) {
        await this.$nextTick();
        this.ultimoDiaPrazoEntregaFinal = objeto.ultimoDiaPrazoEntregaFinal;
        this.ultimoDiaPrazoEntregaLegal = objeto.ultimoDiaPrazoEntregaLegal;

        if(objeto.ultimoDiaPrazoEntregaFinal) {
          this.$refs.inputDiaPrazoEntregaFinal.limparCampo();
          this.$refs.selectMesPrazoEntregaFinal.limparSelect();
          this.$refs.selectMesPrazoEntregaFinal.limparValidacao();
          this.diaPrazoEntregaFinal = "";
          this.isPrazoEntregaFinalAlterado = false;
        }

        if(objeto.ultimoDiaPrazoEntregaLegal) {
          this.$refs.inputDiaPrazoEntregaLegal.limparCampo();
          this.$refs.selectMesPrazoEntregaLegal.limparSelect();
          this.$refs.selectMesPrazoEntregaLegal.limparValidacao();
          this.diaPrazoEntregaLegal = "";
          this.isPrazoEntregaLegalAlterado = false;
        }
    },

    inicilizarEdicaoFases(objeto) {
      this.checkFase = true;
      this.tarefa.complementoTarefa.fases = [
        ...objeto?.complementoTarefa?.fases,
      ];
      this.listagemFases = [...objeto?.complementoTarefa?.fases];
    },

    inicializarEdicaoResponsaveisTarefaCliente(objeto) {
      this.complementoTarefaResponsaveisTarefaCliente = this.tarefaRecebida.complementoTarefa?.responsaveisTarefaCliente;
      if (objeto.tarefaCliente) {
        let responsaveis = objeto?.complementoTarefa?.responsaveisTarefaCliente;
        const listaProcessada = [];

        if(responsaveis) {
          responsaveis.forEach(item => {
          listaProcessada[item.empresaId] = [
            {
              value: item.responsavelId,
              label: item.responsavelNome
            }
          ]
        });

        this.opcaoResponsavelSelecionada = listaProcessada;
        }
      }
    },

    atribuirValoresAoSelectDeUsuariosDasEmpresas() {

      let empresasIds = this.tarefaRecebida.empresas != null ? this.tarefaRecebida.empresas.map((empresa) => empresa.id) : [];
      let complementoDaTarefaRecebida = this.tarefaRecebida.complementoTarefa?.responsaveisTarefaCliente;
      let empresasIdsNoComplementoDaTarefa = complementoDaTarefaRecebida != null ? complementoDaTarefaRecebida.map((complemento) => complemento.empresaId) : [];
      let empresasIdNoComplementoQueNaoEstaoNaTarefa = empresasIdsNoComplementoDaTarefa.filter(id => !empresasIds.includes(id));

      this.opcaoResponsavelSelecionada.forEach((opcao, index) => {
          if(Array.isArray(opcao) && this.opcaoResponsavelSelecionada.length > 0 && !!opcao[0].value 
          && !empresasIdNoComplementoQueNaoEstaoNaTarefa.includes(index)) {
            const selectDaEmpresa = this.$refs[`selectResponsavelTarefaCliente${index}`];
            selectDaEmpresa.iniciarSelectComValor(opcao[0].value);
          }
        });
    },

    inicializarTarefaParcelada(objeto) {
      if (objeto.parcelada) {
        this.disableParcelasEdicao = true;
        this.tarefa.parcelada = objeto.parcelada;
        this.toggleModoParcela(objeto.parcelada);
        objeto?.complementoTarefa?.parcelamento.map((item) => {
          const indexDaEmpresa = this.dataSource.itens.findIndex(
            (empresa) => empresa.id == item.empresaId
          );
          item.parcelaAtual = item.parcelaAtual.toString();
          item.parcelaFinal = item.parcelaFinal.toString();
          item.validacao = {
            atual: {
              isValid: true,
              msg: "",
              disabled: objeto.parcelada,
            },
            final: {
              isValid: true,
              msg: "",
              disabled: false,
            },
          };
          this.dataSource.itens[indexDaEmpresa].parcelamento = item;
        });
        this.$nextTick(() => {
          this.tarefa.competenciaId =
            this.$refs.selectCompetencia.iniciarSelectComValor(
              objeto.competenciaId
            );
          this.$refs.selectCompetencia.verificarSeInputEstaVazio();
        })
      }
    },

    buscaIdsdasEmpresarCadastras(empresas) {
      var ids = [];

      if (!empresas) return ids;

      empresas.forEach((o) => {
        ids.push(o.id);
      });

      return ids;
    },

    converterEmpresasIdsEmArray(empresasIds) {
      var ids = [];

      if (!empresasIds) return ids;

      empresasIds.forEach((o) => {
        ids.push(o);
      });

      return ids;
    },

    inicializarTarefaMensal(objeto) {
      if (
        objeto.recorrencia.id === 2 &&
        objeto.prazoEntrega !== null &&
        (objeto.prazoLegal !== null || this.isTarefaCliente)
      ) {
        this.diaPrazoEntregaFinal =
          this.$refs.inputDiaPrazoEntregaFinal.iniciarInputComValor(
            objeto.prazoEntrega.substr(8)
          );
        this.tarefa.tipoPrazoEntregaFinalId =
          this.$refs.selectMesPrazoEntregaFinal.iniciarSelectComValor(
            objeto.tipoPrazoDeEntregaFinal.id
          );
        this.diaPrazoEntregaLegal = this.isTarefaCliente
          ? objeto.prazoEntrega.substr(8)
          : this.$refs.inputDiaPrazoEntregaLegal.iniciarInputComValor(
              objeto.prazoLegal.substr(8)
            );
        this.tarefa.tipoPrazoEntregaLegalId = this.isTarefaCliente
          ? objeto.tipoPrazoDeEntregaFinal.id
          : this.$refs.selectMesPrazoEntregaLegal.iniciarSelectComValor(
              objeto.tipoPrazoDeEntregaLegal.id
            );
      }
    },
    inicializarTarefaAnual(objeto) {
      if (
        objeto.recorrencia.id === 1 &&
        (objeto.prazoLegal !== null || this.isTarefaCliente) &&
        objeto.prazoEntrega !== null
      ) {
        this.prazoEntrega =
          objeto.prazoEntrega.substr(8) +
          "/" +
          objeto.prazoEntrega.substr(5, 2);

        this.prazoLegal = this.isTarefaCliente
          ? this.prazoEntrega
          : objeto.prazoLegal.substr(8) + "/" + objeto.prazoLegal.substr(5, 2);
      }
    },
    inicializarTarefaTrimestral(objeto) {
      if (
        objeto.recorrencia.id === recorrenciaEnum.TRIMESTRAL &&
        objeto.prazoEntrega !== null &&
        (objeto.prazoLegal !== null || this.isTarefaCliente)
      ) {
        let diaPrazoLegal = !!!objeto.inicioPrazoLegal
          ? objeto.prazoEntrega.substr(8)
          : objeto.inicioPrazoEntrega.toString();
        this.diaPrazoEntregaFinal =
          this.$refs.inputDiaPrazoEntregaFinal.iniciarInputComValor(
            diaPrazoLegal
          );
        this.tarefa.tipoPrazoEntregaFinalId =
          this.$refs.selectMesPrazoEntregaFinal.iniciarSelectComValor(
            objeto.tipoPrazoDeEntregaFinal.id
          );

        let diaPrazoEntrega = !!!objeto.inicioPrazoLegal
          ? objeto.prazoLegal.substr(8)
          : objeto.inicioPrazoLegal.toString();
        this.diaPrazoEntregaLegal = this.isTarefaCliente
          ? objeto.prazoEntrega.substr(8)
          : this.$refs.inputDiaPrazoEntregaLegal.iniciarInputComValor(
              diaPrazoEntrega
            );

        this.tarefa.tipoPrazoEntregaLegalId = this.isTarefaCliente
          ? objeto.tipoPrazoDeEntregaFinal.id
          : this.$refs.selectMesPrazoEntregaLegal.iniciarSelectComValor(
              objeto.tipoPrazoDeEntregaLegal.id
            );
        if (objeto.aPartirDe != null) {
          this.trimestreSelected =
            this.$refs.selectAPartirDe.iniciarSelectComValor(
              this.definirPeriodoPorData(
                this.isTarefaCliente ? objeto.prazoEntrega : objeto.prazoLegal
              )
            );
          this.definirAnoPorData(
            this.isTarefaCliente ? objeto.prazoEntrega : objeto.prazoLegal
          );
        }
      }
    },

    inicializarTarefaSemestral(objeto) {
      if (
        objeto.recorrencia.id === 4 &&
        objeto.prazoEntrega !== null &&
        (objeto.prazoLegal !== null || this.isTarefaCliente)
      ) {
        this.diaPrazoEntregaFinal =
          this.$refs.inputDiaPrazoEntregaFinal.iniciarInputComValor(
            objeto.prazoEntrega.substr(8)
          );
        this.tarefa.tipoPrazoEntregaFinalId =
          this.$refs.selectMesPrazoEntregaFinal.iniciarSelectComValor(
            objeto.tipoPrazoDeEntregaFinal.id
          );
        this.diaPrazoEntregaLegal = this.isTarefaCliente
          ? objeto.prazoEntrega.substr(8)
          : this.$refs.inputDiaPrazoEntregaLegal.iniciarInputComValor(
              objeto.prazoLegal.substr(8)
            );
        this.tarefa.tipoPrazoEntregaLegalId = this.isTarefaCliente
          ? objeto.tipoPrazoDeEntregaFinal.id
          : this.$refs.selectMesPrazoEntregaLegal.iniciarSelectComValor(
              objeto.tipoPrazoDeEntregaLegal.id
            );
        if (objeto.aPartirDe != null) {
          this.semestreSelected =
            this.$refs.selectAPartirDe.iniciarSelectComValor(
              this.definirPeriodoPorData(
                this.isTarefaCliente ? objeto.prazoEntrega : objeto.prazoLegal
              )
            );
          this.definirAnoPorData(
            this.isTarefaCliente ? objeto.prazoEntrega : objeto.prazoLegal
          );
        }
      }
    },

    inicializarTarefaDecendial(objeto) {
      if (
        objeto.recorrencia.id === recorrenciaEnum.DECENDIAL &&
        objeto.inicioPrazoEntrega !== null &&
        (objeto.inicioPrazoLegal !== null || this.isTarefaCliente)
      ) {
        this.tarefa.tipoDecendio =
          this.$refs.selectAPartirDe.iniciarSelectComValor(objeto.tipoDecendio);
        this.diaPrazoEntregaFinal =
          this.$refs.inputDiaPrazoEntregaFinal.iniciarInputComValor(
            objeto.inicioPrazoEntrega.toString()
          );
        this.tarefa.tipoPrazoEntregaFinalId =
          this.$refs.selectMesPrazoEntregaFinal.iniciarSelectComValor(
            objeto.tipoPrazoDeEntregaFinal.id
          );
        this.diaPrazoEntregaLegal = this.isTarefaCliente
          ? objeto.prazoEntrega.substr(8)
          : this.$refs.inputDiaPrazoEntregaLegal.iniciarInputComValor(
              objeto.inicioPrazoLegal.toString()
            );
        this.tarefa.tipoPrazoEntregaLegalId = this.isTarefaCliente
          ? objeto.tipoPrazoDeEntregaFinal.id
          : this.$refs.selectMesPrazoEntregaLegal.iniciarSelectComValor(
              objeto.tipoPrazoDeEntregaLegal.id
            );
      }
    },

    inicializarTarefaSemanal(objeto) {
      if (
        objeto.recorrencia.id === recorrenciaEnum.SEMANAL &&
        objeto.inicioPrazoEntrega !== null &&
        (objeto.inicioPrazoLegal !== null || this.isTarefaCliente)
      ) {
        this.diaPrazoEntregaFinal =
          this.$refs.selectDiaDaSemanaPrazoEntregaFinal.iniciarSelectComValor(
            objeto.inicioPrazoEntrega
          );
        this.diaPrazoEntregaLegal = objeto.inicioPrazoLegal;
        this.aPartirDe =
          objeto.aPartirDe.substring(8, 10) +
          "/" +
          objeto.aPartirDe.substring(5, 7) +
          "/" +
          objeto.aPartirDe.substring(0, 4);
      }
    },

    definirPeriodoPorData(data, aPartirDe) {
      if (this.isTrimestral) {
        const mes = data.substring(5, 7);
        const mesAsInt = parseInt(mes);
        const trimestreEnumValue = Math.floor(mesAsInt / 3);
        return trimestreEnumValue;
      } else if (this.isSemestral) {
        const mes = data.substring(5, 7);
        const mesAsInt = parseInt(mes);
        const semestreEnumValue = mesAsInt == 6 ? 1 : 2;
        return semestreEnumValue;
      }
    },

    definirAnoPorData(data) {
      const ano = data.substring(0, 4);
      this.anoAPartirDe = ano;
    },

    isDadosQueNaoDependemDaInsercaoDoPeriodoDeVigenciaEditados() {
      const isNomeAlterado = this.tarefa.nome != this.tarefaRecebida.nome;
      const isDepartamentoIdAlterado =
        this.tarefa.departamentoId != this.tarefaRecebida.departamentoId;
      const isDepartamentoPadraoIdAlterado =
        this.tarefa.departamentoPadraoId !=
        this.tarefaRecebida.departamentoPadraoId;
      const isGeraMultaAlterado =
        this.tarefa.geraMulta != this.tarefaRecebida.geraMulta;
      const isBaixaPersonalizadaAlterado =
        this.tarefa.baixaPersonalizada !=
        this.tarefaRecebida.baixaPersonalizada;

      return (
        isNomeAlterado ||
        isDepartamentoIdAlterado ||
        isDepartamentoPadraoIdAlterado ||
        isGeraMultaAlterado ||
        isBaixaPersonalizadaAlterado
      );
    },

    isDadosQueDependemDaInsercaoDoPeriodoDeVigenciaEditados() {
      const isAPartirDelAlterado =
        this.tarefa.aPartirDe != this.tarefaRecebida.aPartirDe;
      const isRecorrenciaIdAlterado =
        this.tarefa.recorrenciaId != this.tarefaRecebida.recorrencia.id;
      const isCompetenciaIdAlterado =
        this.tarefa.competenciaId != this.tarefaRecebida.competenciaId;
      const isSabadoDiaUtilAlterado =
        this.tarefa.isSabadoDiaUtil != this.tarefaRecebida.isSabadoDiaUtil;

      let isPrazoEntregaFinalAlterado = false;
      let isPrazoEntregaLegalAlterado = false;
      let isTipoDecendioAlterado = false;
      let isTipoPrazoEntregaLegalIdAlterado = false;
      let isTipoPrazoEntregaFinalIdAlterado = false;

      if (
        !this.isDecendial &&
        !this.isTrimestral &&
        !this.isSemanal &&
        !this.isSemestral
      ) {
        if (this.tarefa.prazoEntrega != "" && !this.tarefa.ultimoDiaPrazoEntregaFinal) {
          isPrazoEntregaFinalAlterado =
            this.tarefa.prazoEntrega != this.tarefaRecebida.prazoEntrega;
        } 
        if (this.tarefa.prazoLegal != "" && !this.tarefa.ultimoDiaPrazoEntregaLegal) {
          isPrazoEntregaLegalAlterado =
            this.tarefa.prazoLegal != this.tarefaRecebida.prazoLegal;
        }
      } else {
        isPrazoEntregaFinalAlterado =
          this.tarefa.inicioPrazoEntrega !=
          this.tarefaRecebida.inicioPrazoEntrega;
        isPrazoEntregaLegalAlterado =
          this.tarefa.inicioPrazoLegal != this.tarefaRecebida.inicioPrazoLegal;
      }
      if (this.isDecendial) {
        isTipoDecendioAlterado =
          this.tarefa.tipoDecendio != this.tarefaRecebida.tipoDecendio;
      }

      if (!this.tarefa.ultimoDiaPrazoEntregaLegal) {
        isTipoPrazoEntregaLegalIdAlterado =
          this.tarefa.tipoPrazoEntregaLegalId !=
          this.tarefaRecebida.tipoPrazoDeEntregaLegal.id;
      }

      if (!this.tarefa.ultimoDiaPrazoEntregaFinal) {
        isTipoPrazoEntregaFinalIdAlterado =
          this.tarefa.tipoPrazoEntregaFinalId !=
          this.tarefaRecebida.tipoPrazoDeEntregaFinal.id;
      }

      const isEmpresasIdsAlterados = this.verificarExistenciaDeNovasEmpresas();

      let isResponsavelAlterado = this.tarefaRecebida.tarefaCliente
        ? false
        : this.tarefa.responsavelId != this.tarefaRecebida.responsavelId;
      const isAtivoAlterado = this.tarefa.ativo && !this.tarefaRecebida.ativo;

      const isFasesAlteradas = this.verificarSeFaseFoiAlterada();

      const isResponsaveisTarefaClienteAlterados = this.verificarSeResponsaveisTarefaClienteForamAlterados();

      const isUltimoDiaPrazoEntregaFinalAlterado = 
        this.tarefa.ultimoDiaPrazoEntregaFinal != 
        this.tarefaRecebida.ultimoDiaPrazoEntregaFinal;
		
      const isUltimoDiaPrazoEntregaLegalAlterado = 
        this.tarefa.ultimoDiaPrazoEntregaLegal != 
        this.tarefaRecebida.ultimoDiaPrazoEntregaLegal;

      const isTipoAjusteVencimentoAlterado = 
        this.tarefa.tipoAjusteVencimentoId != 
        this.tarefaRecebida.tipoAjusteVencimentoId;

      return (
        isAPartirDelAlterado ||
        isRecorrenciaIdAlterado ||
        isCompetenciaIdAlterado ||
        isPrazoEntregaFinalAlterado ||
        isPrazoEntregaLegalAlterado ||
        isResponsavelAlterado ||
        isEmpresasIdsAlterados ||
        isTipoPrazoEntregaLegalIdAlterado ||
        isTipoPrazoEntregaFinalIdAlterado ||
        isTipoDecendioAlterado ||
        isAtivoAlterado ||
        isFasesAlteradas || 
        isResponsaveisTarefaClienteAlterados ||
        isUltimoDiaPrazoEntregaFinalAlterado || 
        isUltimoDiaPrazoEntregaLegalAlterado ||
        isSabadoDiaUtilAlterado ||
        isTipoAjusteVencimentoAlterado
      );
    },

    verificarSeFaseFoiAlterada() {
      const tarefasDeFases =
        !!this.tarefa?.complementoTarefa?.fases &&
        !!this.tarefaRecebida?.complementoTarefa?.fases;
      const quantidadeDiferenteDeFases =
        tarefasDeFases &&
        this.tarefa?.complementoTarefa?.fases.length !=
          this.tarefaRecebida?.complementoTarefa?.fases.length;
      const faseEmEdicaoDiferenteDeFaseEditada =
        tarefasDeFases &&
        JSON.stringify(this.tarefa?.complementoTarefa?.fases) !=
          JSON.stringify(this.tarefaRecebida?.complementoTarefa?.fases);
      const verificarSeTarefaSemFaseVirouTarefaComFase =
        this.tarefaRecebida?.complementoTarefa?.fases == null &&
        this.tarefa?.complementoTarefa?.fases != null;
      const verificarSeTarefaComFaseVirouTarefaSemFase =
        this.tarefaRecebida?.complementoTarefa?.fases != null &&
        this.tarefa?.complementoTarefa?.fases == null;
      return (
        this.edicao &&
        (quantidadeDiferenteDeFases ||
          faseEmEdicaoDiferenteDeFaseEditada ||
          verificarSeTarefaSemFaseVirouTarefaComFase ||
          verificarSeTarefaComFaseVirouTarefaSemFase)
      );
    },

    verificarSeResponsaveisTarefaClienteForamAlterados() {
      const tarefasDoClienteComResponsaveis =
        !!this.tarefa?.complementoTarefa?.responsaveisTarefaCliente &&
        !!this.tarefaRecebida?.complementoTarefa?.responsaveisTarefaCliente;
      const quantidadeDiferenteDeResponsaveis =
      tarefasDoClienteComResponsaveis &&
        this.tarefa?.complementoTarefa?.responsaveisTarefaCliente.length !=
          this.tarefaRecebida?.complementoTarefa?.responsaveisTarefaCliente.length;
      const responsaveisEmEdicaoDiferenteDeResponsaveisDaTarefaDoBanco =
      tarefasDoClienteComResponsaveis &&
        JSON.stringify(this.tarefa?.complementoTarefa?.responsaveisTarefaCliente) !=
          JSON.stringify(this.tarefaRecebida?.complementoTarefa?.responsaveisTarefaCliente);
      return (
        this.edicao &&
        (quantidadeDiferenteDeResponsaveis ||
        responsaveisEmEdicaoDiferenteDeResponsaveisDaTarefaDoBanco)
      );
    },

    verificarSelectResponsavel() {
      if (this.$refs.selectResponsavel != null) {
        if (this.$refs.selectResponsavel.limparValue()) {
          this.tarefa.responsavelId = null;
        }
      }
    },

    showModalDefinicaoPeriodoDeVigencia() {
      const exibirModal =
        this.edicao &&
        this.isDadosQueNaoDependemDaInsercaoDoPeriodoDeVigenciaEditados() &&
        this.isDadosQueDependemDaInsercaoDoPeriodoDeVigenciaEditados();
      return exibirModal;
    },

    verificarExistenciaDeNovasEmpresas() {
      const arrEmpresasDoTarefaCarregada = this.buscaIdsdasEmpresarCadastras(
        this.tarefaRecebida.empresas
      );
      const arrEmpresasEditadas = this.converterEmpresasIdsEmArray(
        this.tarefa.empresasIds
      );
      utils.ordenarArrayNumericamente(arrEmpresasDoTarefaCarregada);
      utils.ordenarArrayNumericamente(arrEmpresasEditadas);

      const hasEmpresaAlterado =
        arrEmpresasDoTarefaCarregada.length != arrEmpresasEditadas.length ||
        !arrEmpresasEditadas.every((id, index) => {
          return id == arrEmpresasDoTarefaCarregada[index];
        });

      return hasEmpresaAlterado;
    },

    verificarEmpresasNovas() {
      const arrEmpresasDoTarefaCarregada = this.buscaIdsdasEmpresarCadastras(
        this.tarefaRecebida.empresas
      );
      const arrEmpresasEditadas = this.converterEmpresasIdsEmArray(
        this.tarefa.empresasIds
      );

      const empresasNovas = arrEmpresasEditadas.filter((editada) => {
        return !arrEmpresasDoTarefaCarregada.includes(editada);
      });

      return empresasNovas.length > 0;
    },

    verificarEmpresasRemovidas() {
      const arrEmpresasDoTarefaCarregada = this.buscaIdsdasEmpresarCadastras(
        this.tarefaRecebida.empresas
      );
      const arrEmpresasEditadas = this.converterEmpresasIdsEmArray(
        this.tarefa.empresasIds
      );

      const empresasRemovidas = arrEmpresasDoTarefaCarregada.filter(
        (editada) => {
          return !arrEmpresasEditadas.includes(editada);
        }
      );

      return empresasRemovidas.length > 0;
    },
    definirAPartirDeTrimestre() {
      const mes = this.adquirirMesTrimestre();
      const ano = this.adquirirAnoTrimestre();
      if (!!!this.trimestreSelected || !!!this.anoAPartirDe || !!!mes || !!!ano)
        return "";
      const data = `${mes}/${ano}`;
      return data;
    },
    adquirirMesTrimestre() {
      if (!!!this.trimestreSelected) return null;
      const mesTrimestre = this.trimestreSelected * 3;
      const mesFormatado = mesTrimestre.toString().padStart(2, "0");
      return mesFormatado;
    },
    adquirirAnoTrimestre() {
      if (!!!this.anoAPartirDe) return null;
      return parseInt(this.anoAPartirDe);
    },
    definirAPartirDeSemestre() {
      const mes = this.adquirirMesSemestre();
      const ano = this.adquirirAnoTrimestre();
      if (!!!this.semestreSelected || !!!this.anoAPartirDe || !!!mes || !!!ano)
        return "";
      const data = `${mes}/${ano}`;
      return data;
    },
    adquirirMesSemestre() {
      if (!!!this.semestreSelected) return null;
      const mesSemestre = this.semestreSelected == 1 ? "6" : "12";
      const mesFormatado = mesSemestre.toString().padStart(2, "0");
      return mesFormatado;
    },
    iniciarCampoLayoutNotificacaoComTextoDefault() {
      const textoInicialLayoutDeNotificacao =
        '<p>Ol&aacute;, <strong>@NomeDestinatario</strong></p><p>Poderia nos encaminhar o <strong>@NomeDaTarefa</strong> do per&iacute;odo <strong>@Periodo</strong> para que seja poss&iacute;vel seguir com os registros?</p><p>Obs: Para seguir com o envio do documento clique em "Enviar Documento" ou acesse a &aacute;rea de Documentos do eContador e/ou eContadorAPP.</p>';
      return this.$refs.textEditorLayoutNotificacao.iniciarTextEditorComValor(
        textoInicialLayoutDeNotificacao
      );
    },
    limparDadosAoTrocarARecorrencia() {
      this.tarefa.tipoDecendio = "";
      this.$refs.selectCompetencia.limparSelect();
      if (this.$refs.selectAPartirDe) {
        this.$refs.selectAPartirDe.limparSelect();
      }

      if (this.tarefa.parcelada == false) {
        this.aPartirDe = "";
      }

      this.ultimoDiaPrazoEntregaFinal = false;
      this.ultimoDiaPrazoEntregaLegal = false;
    },
    isDataDeVigenciaMenorQueAPartirDaTarefa() {
      return this.dataDeVigencia < this.tarefaRecebida.aPartirDe;
    },
    isDataDeVigenciaMenorQueADataDeHoje() {
      const dataDeHoje = new Date();
      const hojeFormatado =
        utils.formatarCampoDataParaEnvioAoBackendSemHora(dataDeHoje);
      return this.dataDeVigencia < hojeFormatado;
    },
    async adquirirTrechosBaixasPersonalizadasTarefa() {
      this.adquirirTrechosBaixasPersonalizadas(this.tarefa.baixaPersonalizada)
    },
    async adquirirTrechosBaixasPersonalizadas(textoBusca) {
      try {
        trechoBaixaPersonalizadaService.abortarUltimoRequest("get");
        this.loadingTrechosBaixasPersonalizadasDocumentos = true;
        const lista = await trechoBaixaPersonalizadaService.listarReferencias(textoBusca);
        this.trechosBaixasPersonalizadas = lista.data.map((trecho) => {
          return trecho.nomePadrao;
        });
        this.loadingTrechosBaixasPersonalizadasDocumentos = false;
      } catch (e) {
        console.warn("WARN:", e);
      }
    },
    verificaPermissoesDoUsuario(responsavel) {
      if (responsavel.id != 1) {
        if (!responsavel.acessaTodosDepartamentos) {
          if (
            !responsavel.idsDepartamentos.includes(
              parseInt(this.tarefa.departamentoId)
            )
          ) {
            const element = this.listaDepartamentos.find(
              (item) => item.value === this.tarefa.departamentoId
            );
            this.departamentosSemPermissao.push(element.label);
          }

          if (Array.isArray(this.tarefa?.complementoTarefa?.fases) && this.tarefa?.complementoTarefa?.fases.length > 0) {
            this.tarefa.complementoTarefa.fases.forEach((fase) => {
              if (!responsavel.idsDepartamentos.includes(parseInt(fase.departamentoId))) {
                const element = this.listaDepartamentosFase.find(
                  (item) => item.value === fase.departamentoId
                );
                this.departamentosSemPermissao.push(element.label);
              }
            })
          }
        }

        if (!responsavel.acessaTodasEmpresas) {
          for (const item of this.dataSource.itens) {
            if (!responsavel.idsEmpresas.includes(item.id)) {
              this.empresasSemPermissao.push(item.nome);
            }
          }
        }
      }
      const objetoPermissoes = {
        departamentosSemPermissao: this.departamentosSemPermissao,
        empresasSemPermissao: this.empresasSemPermissao,
      };

      this.$emit("objetoPermissoes", objetoPermissoes);
    },
    tratarToggleFase() {
      if (this.checkFase) {
        const isEdicaoComFase =
          this.edicao && this.tarefaRecebida?.complementoTarefa?.fases != null;
        this.tarefa.complementoTarefa.fases = isEdicaoComFase
          ? [...this.tarefaRecebida?.complementoTarefa?.fases]
          : null;
        this.listagemFases = isEdicaoComFase
          ? [...this.tarefaRecebida?.complementoTarefa?.fases]
          : [];
      } else {
        this.$refs.cadastroDeFases.limparCamposFase();
        this.tarefa.complementoTarefa.fases = null;
        this.listagemFases = [];
      }
    },
    async upLoadAnexo(e) {
      this.limparArrayTabela();
      for (const arquivo of Array.from(e.target.files)) {
        let base64 = await this.converterArquivoParaBase64(arquivo);
        base64 = base64.split(",")[1];
        const objAnexo = {
          nome: arquivo.name,
          extensao: arquivo.name.split(".").pop().toLowerCase(),
          mime: arquivo.type,
          size: arquivo.size,
          bytes: base64,
        };
        this.tarefa.anexo.push(objAnexo);
        this.anexosCadastro.push(objAnexo);
      }
      this.verificarExtensaoESizeArquivo();
    },
    limparArrayTabela() {
      if (this.dataSourceErro.length > 0) {
        this.dataSourceErro.length = 0;
      }
      if (this.anexosCadastro.length > 0) {
        this.anexosCadastro.length = 0;
      }
    },
    verificarExtensaoESizeArquivo() {
      for (const item of this.anexosCadastro) {
        const nomeCurto = this.gerarNomeCurto(item.nome);
        if (
          !this.extensoesAnexoPermitidas.includes(item.extensao) &&
          item.size > 50 * 1024 * 1024
        ) {
          this.dataSourceErro.itens.push({
            nome: nomeCurto,
            size: (item.size / (1024 * 1024)).toFixed(2) + "MB",
            extensao: item.extensao,
            error: "Erro: Tamanho e Extensão não permitidos",
          });
        } else if (!this.extensoesAnexoPermitidas.includes(item.extensao)) {
          this.dataSourceErro.itens.push({
            nome: nomeCurto,
            size: "-",
            extensao: item.extensao,
            error: "Erro: Extensão não permitida",
          });
        } else if (item.size > 50 * 1024 * 1024) {
          this.dataSourceErro.itens.push({
            nome: nomeCurto,
            size: (item.size / (1024 * 1024)).toFixed(2) + "MB",
            extensao: "-",
            error: "Erro: Tamanho não permitido",
          });
        } else {
          this.isAnexoSemErros = true;
          this.dataSourceErro.itens.push({
            nome: nomeCurto,
            size: (item.size / (1024 * 1024)).toFixed(2) + "MB",
            extensao: item.extensao,
          });
        }
      }
    },
    gerarNomeCurto(nome) {
      if (nome.length > 25) {
        return nome.substring(0, 25) + "...";
      } else {
        return nome;
      }
    },
    async converterArquivoParaBase64(arquivo) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(arquivo);
      });
    },
    showModalGruposTarefaVinculados() {
      this.tituloModal = "Aviso";
      this.modalGruposTarefaVinculados = true;
      this.modalPermissaoAtivo = false;
      this.isBtnLoading = false;
    },
    exibirSelectResponsaveisPorEmpresa() {
      let configuracao = [
        {
          name: "nome",
          label: "Selecionadas",
          style: "width: 50%;",
        },
        {
          name: "responsavelTarefaCliente",
          label: "Selecione o responsável",
          style: "width: 50%",
          slot: true,
        }
      ];

      this.dataSource.columns = configuracao;
    },
    selecionarModelo(id) {
      if (!id) return;
      this.modeloSelecionado = this.listaDeModelos.find((x) => x.id === id);
    },
    limparModelo() {
      if(this.modeloSelecionado != null) {
        this.modeloSelecionado = null;
        this.$refs.selectModelo.limparSelect();
      }
    },
    limparInputsCadastroModelo() {
      if (this.modeloImportado) {
        this.limparDadosCadastroTarefa()
        this.modeloImportado = !this.modeloImportado
      }
    },
    verificarImportacaoDeModelo() {
      const fieldsFilled = !!this.tarefa.nome ||
        !!this.tarefa.responsavelId ||
        !!this.tarefa.departamentoId ||
        !!this.tarefa.descricao ||
        !!this.geraMulta ||
        (Array.isArray(this.listagemFases) && this.listagemFases.length > 0);
      
      if (!fieldsFilled && this.modeloSelecionado != null) {
        this.importarModeloSelecionado();
        return;
      }

      this.$emit("ativarModalCamposModelo", true)
    },
    importarModeloSelecionado() {
      this.tarefa.nome = this.modeloSelecionado.nome;
      this.setDescricaoTarefa(this.modeloSelecionado.descricao);
      if (!!this.modeloSelecionado.responsavelId) {
        this.tarefa.responsavelId = this.modeloSelecionado.responsavelId;
        this.$refs.selectResponsavel.selecionar(this.modeloSelecionado.responsavelId);
      }
      this.tarefa.departamentoId = this.modeloSelecionado.departamentoId.toString();
      this.atributosCadastro.departamentoId = this.modeloSelecionado.departamentoId;
      this.$refs.selectDepartamento.iniciarSelectComValor(
          this.modeloSelecionado.departamentoId.toString()
          );
      if (this.modeloSelecionado.geraMulta) {
        this.tarefa.geraMulta = true;
        this.geraMulta = this.tarefa.geraMulta;
      }
      if (Array.isArray(this.modeloSelecionado.complementoTemplate?.fasesTemplates) && this.modeloSelecionado.complementoTemplate.fasesTemplates.length > 0) {
        this.checkFase = true;
        this.listagemFases = this.modeloSelecionado.complementoTemplate.fasesTemplates;
        const objetoFase = this.listagemFases;
        this.tarefa.complementoTarefa.fases = objetoFase;
      }
      this.limparValidacaoCamposImportadosDoModelo();
      this.modeloImportado = true;
    },
    limparValidacaoCamposImportadosDoModelo() {
      if (!!this.modeloSelecionado.nome) {
        this.$refs.inputNome.limparValidacao();
      }
      if (!!this.modeloSelecionado.departamentoId) {
        this.$refs.selectDepartamento.limparValidacao();
      }
    },
    limparDadosCadastroTarefa() {
      if (!!this.modeloSelecionado.nome) {
        this.tarefa.nome = '';
        this.$refs.inputNome.limparInput();
      }
      if (!!this.modeloSelecionado.descricao) {
        this.tarefa.descricao = '';
        this.$refs.textEditor.limparCampo();
      }
      if (!!this.modeloSelecionado.responsavelId) {
        this.tarefa.responsavelId = '';
        this.$refs.selectResponsavel.limparSelect();
      }
      if (!!this.modeloSelecionado.departamentoId) {
        this.tarefa.departamentoId = '';
        this.$refs.selectDepartamento.limparSelect();
      }
      if (Array.isArray(this.modeloSelecionado.complementoTemplate.fasesTemplates) && this.modeloSelecionado.complementoTemplate.fasesTemplates.length > 0) {
        this.$refs.cadastroDeFases.limparCamposFase();
        this.$refs.cadastroDeFases.limparListagemFases();
        this.tarefa.complementoTarefa.fases = [];
        this.checkFase = false;
      }
      if (this.modeloSelecionado.geraMulta) {
        this.tarefa.geraMulta = false;
      }
    },
    desmarcarCheckbox() {
      if (this.isSelectModeloOpen) {
        this.isSelectModeloOpen = false
      }
    },
    showTooltip() {
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
    handleModeloNovoSelect(value) {
      this.deveCadastrarModelo = value;
    },
    preencherDadosModelo() {
      for (let key in this.modeloCadastro) {
        if (this.tarefa.hasOwnProperty(key)) {
          this.modeloCadastro[key] = this.tarefa[key];
        }
      }
      this.modeloCadastro.complementoTemplate.fasesTemplates = this.tarefa.complementoTarefa.fases;
    },
    async cadastrarModelo() {
      const modeloService = await this.adquirirModeloService();
      const response = await modeloService.cadastrar(this.modeloCadastro);
      if (response.ok) {
        toastUtils.successToast("Modelo cadastrado com sucesso!");
      }
    },
    async adquirirModeloService() {
      const { modeloService } = await import('../../service/modelo-service.js');
      return modeloService;
    },
    async validarCadastroModelo() {

      if (!this.deveCadastrarModelo) return this.deveCadastrarModelo;

      let dadosModeloValidos = '';
      const permissaoModeloService = await this.adquirirPermissaoModeloService();
      dadosModeloValidos = await permissaoModeloService.verificarDados(this.modeloCadastroClone);

      const possuiErros = dadosModeloValidos.length > 0;
      if (!possuiErros) {
        return true;
      }
      toastUtils.dangerToast(dadosModeloValidos[0].erro);
      throw dadosModeloValidos[0].erro;
    },
    async adquirirPermissaoModeloService() {
      const { permissaoModeloService } = await import('../../service/permissao-modelo-service.js');
      return permissaoModeloService;
    },
    deveExibirModalTarefasParceladas($event) {
      if(this.edicao && !this.tarefaRecebida.parcelada && this.tarefa.parcelada && this.gruposTarefaVinculados?.length != 0) {
        this.modalGruposTarefaVinculados = true;
        this.modalGruposTarefaVinculadosParceladas = true;
      } else {
        this.toggleModoParcela($event)
      }
    },
    deveExibirModalGruposTarefasVinculados() {
      if(!this.tarefaRecebida.parcelada && this.tarefa.parcelada) {
        this.modalGruposTarefaVinculadosParceladas = true;
      }

      return this.edicao && this.gruposTarefaVinculados?.length != 0 
                && ((this.tarefaRecebida.ativo && !this.tarefa.ativo) || 
                ((!this.tarefaRecebida.parcelada && this.tarefa.parcelada) && !this.removerTarefasParceladasDoGrupo));
    },
    _getEmpresaObj(e) {
      return {
        id: e.value,
        nome: this.tarefa.parcelada
          ? truncateText(e.label, 25)
          : e.label,
        parcelamento: {
          empresaId: e.value,
          parcelaAtual: "1",
          parcelaFinal: "1",
          validacao: {
            atual: {
              isValid: true,
              msg: "",
              disabled: false,
            },
            final: {
              isValid: true,
              msg: "",
              disabled: false,
            },
          },
        },
      }
    },
    _getValues(array) {
      return array ? array.map(a => a.value) : [];
    },
    
    async setAjustarVencimento(valor) {
      this.ajustarVencimentoDiasNaoUteis = valor;

      if(!valor) {
        this.tarefa.tipoAjusteVencimentoId = null;

        if(this.isSemanal || this.isAnual) {
          this.tarefa.isSabadoDiaUtil = false;
        }

        return;
      }

      if(!this.tarefa.tipoAjusteVencimentoId) {
        this.tarefa.tipoAjusteVencimentoId = tipoAjusteVencimentoEnum.ANTECIPAR;
      }

      this.$refs.radioFieldsAjusteVencimento._selecionarPorValor(this.tarefa.tipoAjusteVencimentoId);

      if(this.isSemanal) {
        this.setDiaDaSemana(this.diaPrazoEntregaFinal);
      }
    },
    
    setTipoAjusteVencimentoId(valor) {
      this.tarefa.tipoAjusteVencimentoId = valor;
    },
  },
  async mounted() {
    if (this.listaRecorrenciaECompetencia) {
      this.listarRecorrencias();
    }
    this.geradorDeDias();
    this.tarefa.tarefaCliente = this.isTarefaCliente;
    if (!this.edicao && this.isTarefaCliente) {
      this.iniciarCampoLayoutNotificacaoComTextoDefault();
    }

    if(this.isTarefaCliente) {
      this.exibirSelectResponsaveisPorEmpresa();
    }
  },
  computed: {
    isSemanal() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.SEMANAL;
    },
    isDecendial() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.DECENDIAL;
    },
    isMensal() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.MENSAL;
    },
    isTrimestral() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.TRIMESTRAL;
    },
    isSemestral() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.SEMESTRAL;
    },
    isAnual() {
      return this.tarefa.recorrenciaId === recorrenciaEnum.ANUAL;
    },
    tipLabelDescricao() {
      let count = this.descricao.maxLength;
      if(this.descricao.plainText) {
        count -= this.descricao.plainText.length;
      }
      return `Adicione informações complementares à tarefa, caso necessário - ${count} caracteres restantes.`;
    },
    listagemFasesExibicao() {
      const fases = this.listagemFases;
      return fases;
    },
    obterOptionsSelectResponsavelEmpresas() {
      let lista = [], listaopcaoResponsavelSelecionadaTratada = [], listaResponsaveisClientesOptionsTratada = []
      if (Array.isArray(this.opcaoResponsavelSelecionada) && this.opcaoResponsavelSelecionada.length > 0) {
        listaopcaoResponsavelSelecionadaTratada = [...this.opcaoResponsavelSelecionada];
      } 
      if (Array.isArray(this.listaResponsaveisClientesOptions) && this.listaResponsaveisClientesOptions.length > 0) {
        listaResponsaveisClientesOptionsTratada = [...this.listaResponsaveisClientesOptions];
      } 

      let maiorListaDeOptions = listaopcaoResponsavelSelecionadaTratada.length > listaResponsaveisClientesOptionsTratada.length? listaopcaoResponsavelSelecionadaTratada : listaResponsaveisClientesOptionsTratada;

      lista = maiorListaDeOptions.map((opcoes, index) => {
        return !!listaResponsaveisClientesOptionsTratada[index] ? listaResponsaveisClientesOptionsTratada[index] : listaopcaoResponsavelSelecionadaTratada[index]
      })

      return lista;
    },
    complementoTarefaParcelamento() {
      if (!this.tarefa.parcelada) return;
      let listaDeParcelas = [];
      this.dataSource.itens.forEach((empresa) => {
        const parcela = {
          empresaId: empresa.parcelamento.empresaId,
          parcelaAtual: parseInt(empresa.parcelamento.parcelaAtual),
          parcelaFinal: parseInt(empresa.parcelamento.parcelaFinal),
        };
        listaDeParcelas.push(parcela);
      });
      return listaDeParcelas;
    },
    decendioEnum() {
      const decendioEnum = {
        PRIMEIRO: {
          value: 1,
          diasASeremSubtraidos: 9,
          diasASeremAdicionados: 11,
          ultimoDia: 15,
        },
        SEGUNDO: {
          value: 2,
          diasASeremSubtraidos: 19,
          diasASeremAdicionados: 21,
          ultimoDia: 25,
        },
        TERCEIRO: {
          value: 3,
          diasASeremSubtraidos: 29,
          diasASeremAdicionados: 31,
        },
      };
      return decendioEnum;
    },
    nomeTarefa() {
      return this.tarefa.nome;
    },
    placeholderEmpresa() {
      let placeholder = "Selecione uma ou mais empresas";
      if (this.dataSource.itens.length == 1) {
        placeholder = "1 empresa selecionada";
      } else if (this.dataSource.itens.length > 1) {
        placeholder = `${this.dataSource.itens.length} empresas selecionadas`;
      }
      return placeholder;
    },
    hasCustomEmpresaPlaceholder() {
      return this.dataSource.itens.length > 0;
    },
    mensagemModalVigencia() {
      if (this.verificarEmpresasNovas()) {
        return "Informe a data de início de controle da tarefa para as novas empresas adicionadas:";
      }

      if (this.verificarEmpresasRemovidas()) {
        return "Informe a data de remoção de controle da tarefa para as empresas removidas:";
      }

      if (this.verificarSeFaseFoiAlterada()) {
        return "Informe o período em que entrarão em vigor as novas alterações:";
      }

      return "Informe o período em que entrarão em vigor as novas alterações:";
    },
    deveExibirAvisoGuiasIssEIcms() {
      return (
        this.edicao &&
        (this.tarefaRecebida?.isGuiaICMS || this.tarefaRecebida?.isGuiaISS)
      );
    },
    tipoDaGuia() {
      return this.tarefaRecebida?.isGuiaISS ? "Guia de ISS" : "Guia de ICMS";
    },
    infoLink() {
      return this.tarefaRecebida?.isGuiaISS
        ? "https://alterdata.software/ISS-removerEmpresa"
        : "https://alterdata.software/ICMS-removerEmpresa";
    },
    isCategoriaPersonalizada() {
      return this.tarefa.categoriaId == 99
    },
    tituloTip() {
      return 'Selecione esta opção se deseja importar um modelo cadastrado no módulo "Cadastro de modelos"';
    },
    usuarioTemPermissaoDeAdmin() {
      return !this.pessoaLogada.Permissoes || this.pessoaLogada.isSuperAdm || this.pessoaLogada.Administrador;
    },
    usuarioTemPermissaoNoModulo() {
      return pessoaLogada.hasPermissao("AcessoTemplatesTarefas") || this.usuarioTemPermissaoDeAdmin;
    },
    usuarioTemPermissaoDeCriacaoDeModelo() {
      return this.usuarioTemPermissaoDeAdmin || (this.usuarioTemPermissaoNoModulo && this.pessoaLogada.Permissoes.Tarefas.Criar);
    },
    modeloCadastroClone() {
      return Object.assign({}, this.modeloCadastro);
    },
    hasRecorrencia() {
      return !!this.tarefa.recorrenciaId;
    },
    deveExibirAjusteVencimentoDiasNaoUteis() {
      if (this.isTarefaAvulsa) return false;
      if (this.ultimoDiaPrazoEntregaFinal && this.ultimoDiaPrazoEntregaLegal) return false;
      if (this.tarefa.tipoPrazoEntregaLegalId == tipoPrazoDeEntregaEnum.DIA_UTIL.getId() && this.tarefa.tipoPrazoEntregaFinalId == tipoPrazoDeEntregaEnum.DIA_UTIL.getId()) return false;
      return this.hasRecorrencia;
    },
    isSabadoSelecionado() {
      if(!this.isSemanal) return false;
      return this.diaPrazoEntregaFinal == diaDaSemanaEnum.SABADO.getId() || this.diaPrazoEntregaLegal == diaDaSemanaEnum.SABADO.getId();
    },
    deveExibirSabadoDiaUtil() {
      if(!this.hasRecorrencia) return false;      
      if(this.isSemanal || this.isAnual) {
        return this.tarefa.tipoAjusteVencimentoId != null;
      }
      return true;
    }
  },
  watch: {
    nomeTarefa(novoValor, antigoValor) {
      if (!this.isTarefaCliente) return;
      if (
        (!!!this.tarefa.baixaPersonalizada ||
          this.tarefa.baixaPersonalizada == antigoValor) &&
        this.tarefa.baixaPersonalizada != novoValor
      ) {
        this.tarefa.baixaPersonalizada = novoValor;
      }
    },
    titulo() {
      this.tituloModal = this.titulo;
    },
    edicao() {
      this.tabSelecionada = "cadastro";
    },
    listaRecorrenciaECompetencia() {
      if (this.listaRecorrenciaECompetencia) {
        this.listarRecorrencias();
      }
    },
    anoAPartirDe() {
      this.aPartirDe = this.isTrimestral
        ? this.definirAPartirDeTrimestre()
        : this.definirAPartirDeSemestre();
    },
    trimestreSelected() {
      this.aPartirDe = this.definirAPartirDeTrimestre();
    },
    semestreSelected() {
      this.aPartirDe = this.definirAPartirDeSemestre();
    },
    deveExibirAjusteVencimentoDiasNaoUteis(novoValor) {
      if (!novoValor) {
        this.setAjustarVencimento(false);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.switch {
  position: relative;
  display: inline-block;
  width: 25px;
  height: 16px;
  margin-left: 8px;
  input {
    opacity: 0;
    width: 0px;
    height: 0px;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primaryColor, $primary);
}

input:checked + .slider:before {
  -webkit-transform: translateX(8px);
  -ms-transform: translateX(8px);
  transform: translateX(8px);
}

.slider.round {
  border-radius: 10px;
}

.slider.round:before {
  border-radius: 50%;
}

.posicao-switcher-status-tarefa {
  display: inline;
  position: absolute;
  bottom: 54px;
  right: 0;
}

.posicao-switcher-status-tarefa-validacao-campos {
  display: inline;
  position: absolute;
  right: 0;
  bottom: 72px;
}

div.columns {
  margin-bottom: 0;
  margin-top: 0;
  .is-6,
  .is-6-desktop,
  .is-12-mobile,
  .is-8-desktop,
  .is-8-mobile,
  .is-4-desktop,
  .is-6-mobile,
  .is-4-mobile {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.switcher-container {
  position: relative;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
}

.container-descricao {
  margin-bottom: 15px;
  height: 266px;
}

.container-anexos {
  margin-bottom: 15px;
}

#btn-add-todas-empresas {
  margin-right: 5px;
}

h1 {
  text-align: right;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  height: 15px;
  margin: 0 0 10px 0;
  color: #a94442;
  font-size: 12px;
}

td > .mensagemDeErro {
  height: auto;
  margin-bottom: 0;
}
.labelObrigatorio {
  color: #a94442;
}
.container-baixa-padrao {
  margin-bottom: 15px;
}
.container-baixa-padrao p:first-of-type > a:first-of-type {
  color: var(--primaryColor, $primary);
}

.card-info-body strong,
p.card-info-body {
  font-size: 12px;
  color: #31708f;
}

.columns.is-form {
  .column {
    padding-bottom: 0 !important;
  }
}
.tip-label-grupo {
  font-style: italic;
  font-size: 12px;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: auto; 
  max-width: 400px; 
  background-color: #555;
  color: #fff;
  text-align: left; 
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 110%; 
  transform: translateY(-50%);
  white-space: nowrap; 
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #555 transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.vertical-align-middle {
  vertical-align: middle;
}

.container-switch {
  margin-bottom: 20px;
  margin-top: -5px;
}

.switch-label {
  margin-bottom: 0px;
  vertical-align: middle;
}

.help-switch {
  margin-left: 8px;
  vertical-align: text-bottom;
}

.mensagemErroPersonalizada {
  margin-top:-12px;
  margin-bottom: -2px;
  padding-bottom: 0px;
}
.labelErroPersonalizado {
  font-size: 12px;
}
</style>
<style lang="scss">
// precisa ser global para afetar o filho diretamente
#select-add-empresa-nova-tarefa.trf-is-placeholder-customizado
  .multiselect-placeholder {
  color: #000 !important;
}
@media screen and (min-width: 769px) {
  .modal-cadastro-tarefas .modal-card.modal-card-personalizado {
    width: 700px;
  }
}

.has-checkbox-ultimo-dia .input-container, .has-checkbox-ultimo-dia .select-container {
  margin-bottom:0;
  .field {
    margin-bottom: 0;
  }
  .mensagemDeErro {
    margin-top:-12px;
  }
}
</style>
